(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.LiveResource = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };
},{"core-js/library/fn/array/from":25}],2:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/get-iterator"), __esModule: true };
},{"core-js/library/fn/get-iterator":26}],3:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/json/stringify"), __esModule: true };
},{"core-js/library/fn/json/stringify":27}],4:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/map"), __esModule: true };
},{"core-js/library/fn/map":28}],5:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };
},{"core-js/library/fn/object/assign":29}],6:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };
},{"core-js/library/fn/object/create":30}],7:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };
},{"core-js/library/fn/object/define-property":31}],8:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/get-own-property-descriptor"), __esModule: true };
},{"core-js/library/fn/object/get-own-property-descriptor":32}],9:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/get-prototype-of"), __esModule: true };
},{"core-js/library/fn/object/get-prototype-of":33}],10:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/keys"), __esModule: true };
},{"core-js/library/fn/object/keys":34}],11:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/set-prototype-of"), __esModule: true };
},{"core-js/library/fn/object/set-prototype-of":35}],12:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/promise"), __esModule: true };
},{"core-js/library/fn/promise":36}],13:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };
},{"core-js/library/fn/symbol":37}],14:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/symbol/iterator"), __esModule: true };
},{"core-js/library/fn/symbol/iterator":38}],15:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/weak-map"), __esModule: true };
},{"core-js/library/fn/weak-map":39}],16:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _promise = require("../core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};
},{"../core-js/promise":12}],17:[function(require,module,exports){
"use strict";

exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
},{}],18:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _defineProperty = require("../core-js/object/define-property");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
},{"../core-js/object/define-property":7}],19:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _getPrototypeOf = require("../core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _getOwnPropertyDescriptor = require("../core-js/object/get-own-property-descriptor");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);

  if (desc === undefined) {
    var parent = (0, _getPrototypeOf2.default)(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};
},{"../core-js/object/get-own-property-descriptor":8,"../core-js/object/get-prototype-of":9}],20:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _setPrototypeOf = require("../core-js/object/set-prototype-of");

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = require("../core-js/object/create");

var _create2 = _interopRequireDefault(_create);

var _typeof2 = require("../helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};
},{"../core-js/object/create":6,"../core-js/object/set-prototype-of":11,"../helpers/typeof":23}],21:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _typeof2 = require("../helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};
},{"../helpers/typeof":23}],22:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _from = require("../core-js/array/from");

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};
},{"../core-js/array/from":1}],23:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _iterator = require("../core-js/symbol/iterator");

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = require("../core-js/symbol");

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};
},{"../core-js/symbol":13,"../core-js/symbol/iterator":14}],24:[function(require,module,exports){
module.exports = require("regenerator-runtime");

},{"regenerator-runtime":149}],25:[function(require,module,exports){
require('../../modules/es6.string.iterator');
require('../../modules/es6.array.from');
module.exports = require('../../modules/_core').Array.from;
},{"../../modules/_core":55,"../../modules/es6.array.from":122,"../../modules/es6.string.iterator":134}],26:[function(require,module,exports){
require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.get-iterator');
},{"../modules/core.get-iterator":121,"../modules/es6.string.iterator":134,"../modules/web.dom.iterable":140}],27:[function(require,module,exports){
var core  = require('../../modules/_core')
  , $JSON = core.JSON || (core.JSON = {stringify: JSON.stringify});
module.exports = function stringify(it){ // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};
},{"../../modules/_core":55}],28:[function(require,module,exports){
require('../modules/es6.object.to-string');
require('../modules/es6.string.iterator');
require('../modules/web.dom.iterable');
require('../modules/es6.map');
require('../modules/es7.map.to-json');
module.exports = require('../modules/_core').Map;
},{"../modules/_core":55,"../modules/es6.map":124,"../modules/es6.object.to-string":132,"../modules/es6.string.iterator":134,"../modules/es7.map.to-json":137,"../modules/web.dom.iterable":140}],29:[function(require,module,exports){
require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;
},{"../../modules/_core":55,"../../modules/es6.object.assign":125}],30:[function(require,module,exports){
require('../../modules/es6.object.create');
var $Object = require('../../modules/_core').Object;
module.exports = function create(P, D){
  return $Object.create(P, D);
};
},{"../../modules/_core":55,"../../modules/es6.object.create":126}],31:[function(require,module,exports){
require('../../modules/es6.object.define-property');
var $Object = require('../../modules/_core').Object;
module.exports = function defineProperty(it, key, desc){
  return $Object.defineProperty(it, key, desc);
};
},{"../../modules/_core":55,"../../modules/es6.object.define-property":127}],32:[function(require,module,exports){
require('../../modules/es6.object.get-own-property-descriptor');
var $Object = require('../../modules/_core').Object;
module.exports = function getOwnPropertyDescriptor(it, key){
  return $Object.getOwnPropertyDescriptor(it, key);
};
},{"../../modules/_core":55,"../../modules/es6.object.get-own-property-descriptor":128}],33:[function(require,module,exports){
require('../../modules/es6.object.get-prototype-of');
module.exports = require('../../modules/_core').Object.getPrototypeOf;
},{"../../modules/_core":55,"../../modules/es6.object.get-prototype-of":129}],34:[function(require,module,exports){
require('../../modules/es6.object.keys');
module.exports = require('../../modules/_core').Object.keys;
},{"../../modules/_core":55,"../../modules/es6.object.keys":130}],35:[function(require,module,exports){
require('../../modules/es6.object.set-prototype-of');
module.exports = require('../../modules/_core').Object.setPrototypeOf;
},{"../../modules/_core":55,"../../modules/es6.object.set-prototype-of":131}],36:[function(require,module,exports){
require('../modules/es6.object.to-string');
require('../modules/es6.string.iterator');
require('../modules/web.dom.iterable');
require('../modules/es6.promise');
module.exports = require('../modules/_core').Promise;
},{"../modules/_core":55,"../modules/es6.object.to-string":132,"../modules/es6.promise":133,"../modules/es6.string.iterator":134,"../modules/web.dom.iterable":140}],37:[function(require,module,exports){
require('../../modules/es6.symbol');
require('../../modules/es6.object.to-string');
require('../../modules/es7.symbol.async-iterator');
require('../../modules/es7.symbol.observable');
module.exports = require('../../modules/_core').Symbol;
},{"../../modules/_core":55,"../../modules/es6.object.to-string":132,"../../modules/es6.symbol":135,"../../modules/es7.symbol.async-iterator":138,"../../modules/es7.symbol.observable":139}],38:[function(require,module,exports){
require('../../modules/es6.string.iterator');
require('../../modules/web.dom.iterable');
module.exports = require('../../modules/_wks-ext').f('iterator');
},{"../../modules/_wks-ext":118,"../../modules/es6.string.iterator":134,"../../modules/web.dom.iterable":140}],39:[function(require,module,exports){
require('../modules/es6.object.to-string');
require('../modules/web.dom.iterable');
require('../modules/es6.weak-map');
module.exports = require('../modules/_core').WeakMap;
},{"../modules/_core":55,"../modules/es6.object.to-string":132,"../modules/es6.weak-map":136,"../modules/web.dom.iterable":140}],40:[function(require,module,exports){
module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};
},{}],41:[function(require,module,exports){
module.exports = function(){ /* empty */ };
},{}],42:[function(require,module,exports){
module.exports = function(it, Constructor, name, forbiddenField){
  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};
},{}],43:[function(require,module,exports){
var isObject = require('./_is-object');
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};
},{"./_is-object":75}],44:[function(require,module,exports){
var forOf = require('./_for-of');

module.exports = function(iter, ITERATOR){
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};

},{"./_for-of":65}],45:[function(require,module,exports){
// false -> Array#indexOf
// true  -> Array#includes
var toIObject = require('./_to-iobject')
  , toLength  = require('./_to-length')
  , toIndex   = require('./_to-index');
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};
},{"./_to-index":110,"./_to-iobject":112,"./_to-length":113}],46:[function(require,module,exports){
// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx      = require('./_ctx')
  , IObject  = require('./_iobject')
  , toObject = require('./_to-object')
  , toLength = require('./_to-length')
  , asc      = require('./_array-species-create');
module.exports = function(TYPE, $create){
  var IS_MAP        = TYPE == 1
    , IS_FILTER     = TYPE == 2
    , IS_SOME       = TYPE == 3
    , IS_EVERY      = TYPE == 4
    , IS_FIND_INDEX = TYPE == 6
    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX
    , create        = $create || asc;
  return function($this, callbackfn, that){
    var O      = toObject($this)
      , self   = IObject(O)
      , f      = ctx(callbackfn, that, 3)
      , length = toLength(self.length)
      , index  = 0
      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
      , val, res;
    for(;length > index; index++)if(NO_HOLES || index in self){
      val = self[index];
      res = f(val, index, O);
      if(TYPE){
        if(IS_MAP)result[index] = res;            // map
        else if(res)switch(TYPE){
          case 3: return true;                    // some
          case 5: return val;                     // find
          case 6: return index;                   // findIndex
          case 2: result.push(val);               // filter
        } else if(IS_EVERY)return false;          // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};
},{"./_array-species-create":48,"./_ctx":57,"./_iobject":72,"./_to-length":113,"./_to-object":114}],47:[function(require,module,exports){
var isObject = require('./_is-object')
  , isArray  = require('./_is-array')
  , SPECIES  = require('./_wks')('species');

module.exports = function(original){
  var C;
  if(isArray(original)){
    C = original.constructor;
    // cross-realm fallback
    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
    if(isObject(C)){
      C = C[SPECIES];
      if(C === null)C = undefined;
    }
  } return C === undefined ? Array : C;
};
},{"./_is-array":74,"./_is-object":75,"./_wks":119}],48:[function(require,module,exports){
// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = require('./_array-species-constructor');

module.exports = function(original, length){
  return new (speciesConstructor(original))(length);
};
},{"./_array-species-constructor":47}],49:[function(require,module,exports){
// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = require('./_cof')
  , TAG = require('./_wks')('toStringTag')
  // ES3 wrong here
  , ARG = cof(function(){ return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function(it, key){
  try {
    return it[key];
  } catch(e){ /* empty */ }
};

module.exports = function(it){
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};
},{"./_cof":50,"./_wks":119}],50:[function(require,module,exports){
var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};
},{}],51:[function(require,module,exports){
'use strict';
var dP          = require('./_object-dp').f
  , create      = require('./_object-create')
  , redefineAll = require('./_redefine-all')
  , ctx         = require('./_ctx')
  , anInstance  = require('./_an-instance')
  , defined     = require('./_defined')
  , forOf       = require('./_for-of')
  , $iterDefine = require('./_iter-define')
  , step        = require('./_iter-step')
  , setSpecies  = require('./_set-species')
  , DESCRIPTORS = require('./_descriptors')
  , fastKey     = require('./_meta').fastKey
  , SIZE        = DESCRIPTORS ? '_s' : 'size';

var getEntry = function(that, key){
  // fast case
  var index = fastKey(key), entry;
  if(index !== 'F')return that._i[index];
  // frozen object case
  for(entry = that._f; entry; entry = entry.n){
    if(entry.k == key)return entry;
  }
};

module.exports = {
  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
    var C = wrapper(function(that, iterable){
      anInstance(that, C, NAME, '_i');
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear(){
        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
          entry.r = true;
          if(entry.p)entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function(key){
        var that  = this
          , entry = getEntry(that, key);
        if(entry){
          var next = entry.n
            , prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if(prev)prev.n = next;
          if(next)next.p = prev;
          if(that._f == entry)that._f = next;
          if(that._l == entry)that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /*, that = undefined */){
        anInstance(this, C, 'forEach');
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
          , entry;
        while(entry = entry ? entry.n : this._f){
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while(entry && entry.r)entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key){
        return !!getEntry(this, key);
      }
    });
    if(DESCRIPTORS)dP(C.prototype, 'size', {
      get: function(){
        return defined(this[SIZE]);
      }
    });
    return C;
  },
  def: function(that, key, value){
    var entry = getEntry(that, key)
      , prev, index;
    // change existing entry
    if(entry){
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if(!that._f)that._f = entry;
      if(prev)prev.n = entry;
      that[SIZE]++;
      // add to index
      if(index !== 'F')that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function(C, NAME, IS_MAP){
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function(iterated, kind){
      this._t = iterated;  // target
      this._k = kind;      // kind
      this._l = undefined; // previous
    }, function(){
      var that  = this
        , kind  = that._k
        , entry = that._l;
      // revert to the last existing entry
      while(entry && entry.r)entry = entry.p;
      // get next entry
      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if(kind == 'keys'  )return step(0, entry.k);
      if(kind == 'values')return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};
},{"./_an-instance":42,"./_ctx":57,"./_defined":58,"./_descriptors":59,"./_for-of":65,"./_iter-define":78,"./_iter-step":80,"./_meta":84,"./_object-create":87,"./_object-dp":88,"./_redefine-all":100,"./_set-species":103}],52:[function(require,module,exports){
// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = require('./_classof')
  , from    = require('./_array-from-iterable');
module.exports = function(NAME){
  return function toJSON(){
    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};
},{"./_array-from-iterable":44,"./_classof":49}],53:[function(require,module,exports){
'use strict';
var redefineAll       = require('./_redefine-all')
  , getWeak           = require('./_meta').getWeak
  , anObject          = require('./_an-object')
  , isObject          = require('./_is-object')
  , anInstance        = require('./_an-instance')
  , forOf             = require('./_for-of')
  , createArrayMethod = require('./_array-methods')
  , $has              = require('./_has')
  , arrayFind         = createArrayMethod(5)
  , arrayFindIndex    = createArrayMethod(6)
  , id                = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function(that){
  return that._l || (that._l = new UncaughtFrozenStore);
};
var UncaughtFrozenStore = function(){
  this.a = [];
};
var findUncaughtFrozen = function(store, key){
  return arrayFind(store.a, function(it){
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function(key){
    var entry = findUncaughtFrozen(this, key);
    if(entry)return entry[1];
  },
  has: function(key){
    return !!findUncaughtFrozen(this, key);
  },
  set: function(key, value){
    var entry = findUncaughtFrozen(this, key);
    if(entry)entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function(key){
    var index = arrayFindIndex(this.a, function(it){
      return it[0] === key;
    });
    if(~index)this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
    var C = wrapper(function(that, iterable){
      anInstance(that, C, NAME, '_i');
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function(key){
        if(!isObject(key))return false;
        var data = getWeak(key);
        if(data === true)return uncaughtFrozenStore(this)['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key){
        if(!isObject(key))return false;
        var data = getWeak(key);
        if(data === true)return uncaughtFrozenStore(this).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function(that, key, value){
    var data = getWeak(anObject(key), true);
    if(data === true)uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};
},{"./_an-instance":42,"./_an-object":43,"./_array-methods":46,"./_for-of":65,"./_has":67,"./_is-object":75,"./_meta":84,"./_redefine-all":100}],54:[function(require,module,exports){
'use strict';
var global         = require('./_global')
  , $export        = require('./_export')
  , meta           = require('./_meta')
  , fails          = require('./_fails')
  , hide           = require('./_hide')
  , redefineAll    = require('./_redefine-all')
  , forOf          = require('./_for-of')
  , anInstance     = require('./_an-instance')
  , isObject       = require('./_is-object')
  , setToStringTag = require('./_set-to-string-tag')
  , dP             = require('./_object-dp').f
  , each           = require('./_array-methods')(0)
  , DESCRIPTORS    = require('./_descriptors');

module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
  var Base  = global[NAME]
    , C     = Base
    , ADDER = IS_MAP ? 'set' : 'add'
    , proto = C && C.prototype
    , O     = {};
  if(!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
    new C().entries().next();
  }))){
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function(target, iterable){
      anInstance(target, C, NAME, '_c');
      target._c = new Base;
      if(iterable != undefined)forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','),function(KEY){
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if(KEY in proto && !(IS_WEAK && KEY == 'clear'))hide(C.prototype, KEY, function(a, b){
        anInstance(this, C, KEY);
        if(!IS_ADDER && IS_WEAK && !isObject(a))return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    if('size' in proto)dP(C.prototype, 'size', {
      get: function(){
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);

  return C;
};
},{"./_an-instance":42,"./_array-methods":46,"./_descriptors":59,"./_export":63,"./_fails":64,"./_for-of":65,"./_global":66,"./_hide":68,"./_is-object":75,"./_meta":84,"./_object-dp":88,"./_redefine-all":100,"./_set-to-string-tag":104}],55:[function(require,module,exports){
var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef
},{}],56:[function(require,module,exports){
'use strict';
var $defineProperty = require('./_object-dp')
  , createDesc      = require('./_property-desc');

module.exports = function(object, index, value){
  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};
},{"./_object-dp":88,"./_property-desc":99}],57:[function(require,module,exports){
// optional / simple context binding
var aFunction = require('./_a-function');
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};
},{"./_a-function":40}],58:[function(require,module,exports){
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};
},{}],59:[function(require,module,exports){
// Thank's IE8 for his funny defineProperty
module.exports = !require('./_fails')(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});
},{"./_fails":64}],60:[function(require,module,exports){
var isObject = require('./_is-object')
  , document = require('./_global').document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};
},{"./_global":66,"./_is-object":75}],61:[function(require,module,exports){
// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');
},{}],62:[function(require,module,exports){
// all enumerable object keys, includes symbols
var getKeys = require('./_object-keys')
  , gOPS    = require('./_object-gops')
  , pIE     = require('./_object-pie');
module.exports = function(it){
  var result     = getKeys(it)
    , getSymbols = gOPS.f;
  if(getSymbols){
    var symbols = getSymbols(it)
      , isEnum  = pIE.f
      , i       = 0
      , key;
    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
  } return result;
};
},{"./_object-gops":93,"./_object-keys":96,"./_object-pie":97}],63:[function(require,module,exports){
var global    = require('./_global')
  , core      = require('./_core')
  , ctx       = require('./_ctx')
  , hide      = require('./_hide')
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE]
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(a, b, c){
        if(this instanceof C){
          switch(arguments.length){
            case 0: return new C;
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if(IS_PROTO){
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;
},{"./_core":55,"./_ctx":57,"./_global":66,"./_hide":68}],64:[function(require,module,exports){
module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};
},{}],65:[function(require,module,exports){
var ctx         = require('./_ctx')
  , call        = require('./_iter-call')
  , isArrayIter = require('./_is-array-iter')
  , anObject    = require('./_an-object')
  , toLength    = require('./_to-length')
  , getIterFn   = require('./core.get-iterator-method')
  , BREAK       = {}
  , RETURN      = {};
var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
    , f      = ctx(fn, that, entries ? 2 : 1)
    , index  = 0
    , length, step, iterator, result;
  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if(result === BREAK || result === RETURN)return result;
  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
    result = call(iterator, f, step.value, entries);
    if(result === BREAK || result === RETURN)return result;
  }
};
exports.BREAK  = BREAK;
exports.RETURN = RETURN;
},{"./_an-object":43,"./_ctx":57,"./_is-array-iter":73,"./_iter-call":76,"./_to-length":113,"./core.get-iterator-method":120}],66:[function(require,module,exports){
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef
},{}],67:[function(require,module,exports){
var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};
},{}],68:[function(require,module,exports){
var dP         = require('./_object-dp')
  , createDesc = require('./_property-desc');
module.exports = require('./_descriptors') ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};
},{"./_descriptors":59,"./_object-dp":88,"./_property-desc":99}],69:[function(require,module,exports){
module.exports = require('./_global').document && document.documentElement;
},{"./_global":66}],70:[function(require,module,exports){
module.exports = !require('./_descriptors') && !require('./_fails')(function(){
  return Object.defineProperty(require('./_dom-create')('div'), 'a', {get: function(){ return 7; }}).a != 7;
});
},{"./_descriptors":59,"./_dom-create":60,"./_fails":64}],71:[function(require,module,exports){
// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that){
  var un = that === undefined;
  switch(args.length){
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return              fn.apply(that, args);
};
},{}],72:[function(require,module,exports){
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = require('./_cof');
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};
},{"./_cof":50}],73:[function(require,module,exports){
// check on default Array iterator
var Iterators  = require('./_iterators')
  , ITERATOR   = require('./_wks')('iterator')
  , ArrayProto = Array.prototype;

module.exports = function(it){
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};
},{"./_iterators":81,"./_wks":119}],74:[function(require,module,exports){
// 7.2.2 IsArray(argument)
var cof = require('./_cof');
module.exports = Array.isArray || function isArray(arg){
  return cof(arg) == 'Array';
};
},{"./_cof":50}],75:[function(require,module,exports){
module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};
},{}],76:[function(require,module,exports){
// call something on iterator step with safe closing on error
var anObject = require('./_an-object');
module.exports = function(iterator, fn, value, entries){
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch(e){
    var ret = iterator['return'];
    if(ret !== undefined)anObject(ret.call(iterator));
    throw e;
  }
};
},{"./_an-object":43}],77:[function(require,module,exports){
'use strict';
var create         = require('./_object-create')
  , descriptor     = require('./_property-desc')
  , setToStringTag = require('./_set-to-string-tag')
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
require('./_hide')(IteratorPrototype, require('./_wks')('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};
},{"./_hide":68,"./_object-create":87,"./_property-desc":99,"./_set-to-string-tag":104,"./_wks":119}],78:[function(require,module,exports){
'use strict';
var LIBRARY        = require('./_library')
  , $export        = require('./_export')
  , redefine       = require('./_redefine')
  , hide           = require('./_hide')
  , has            = require('./_has')
  , Iterators      = require('./_iterators')
  , $iterCreate    = require('./_iter-create')
  , setToStringTag = require('./_set-to-string-tag')
  , getPrototypeOf = require('./_object-gpo')
  , ITERATOR       = require('./_wks')('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
    , methods, key, IteratorPrototype;
  // Fix native
  if($anyNative){
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
    if(IteratorPrototype !== Object.prototype){
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if(DEF_VALUES && $native && $native.name !== VALUES){
    VALUES_BUG = true;
    $default = function values(){ return $native.call(this); };
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES ? $default : getMethod(VALUES),
      keys:    IS_SET     ? $default : getMethod(KEYS),
      entries: $entries
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};
},{"./_export":63,"./_has":67,"./_hide":68,"./_iter-create":77,"./_iterators":81,"./_library":83,"./_object-gpo":94,"./_redefine":101,"./_set-to-string-tag":104,"./_wks":119}],79:[function(require,module,exports){
var ITERATOR     = require('./_wks')('iterator')
  , SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function(){ SAFE_CLOSING = true; };
  Array.from(riter, function(){ throw 2; });
} catch(e){ /* empty */ }

module.exports = function(exec, skipClosing){
  if(!skipClosing && !SAFE_CLOSING)return false;
  var safe = false;
  try {
    var arr  = [7]
      , iter = arr[ITERATOR]();
    iter.next = function(){ return {done: safe = true}; };
    arr[ITERATOR] = function(){ return iter; };
    exec(arr);
  } catch(e){ /* empty */ }
  return safe;
};
},{"./_wks":119}],80:[function(require,module,exports){
module.exports = function(done, value){
  return {value: value, done: !!done};
};
},{}],81:[function(require,module,exports){
module.exports = {};
},{}],82:[function(require,module,exports){
var getKeys   = require('./_object-keys')
  , toIObject = require('./_to-iobject');
module.exports = function(object, el){
  var O      = toIObject(object)
    , keys   = getKeys(O)
    , length = keys.length
    , index  = 0
    , key;
  while(length > index)if(O[key = keys[index++]] === el)return key;
};
},{"./_object-keys":96,"./_to-iobject":112}],83:[function(require,module,exports){
module.exports = true;
},{}],84:[function(require,module,exports){
var META     = require('./_uid')('meta')
  , isObject = require('./_is-object')
  , has      = require('./_has')
  , setDesc  = require('./_object-dp').f
  , id       = 0;
var isExtensible = Object.isExtensible || function(){
  return true;
};
var FREEZE = !require('./_fails')(function(){
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function(it){
  setDesc(it, META, {value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  }});
};
var fastKey = function(it, create){
  // return primitive with prefix
  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return 'F';
    // not necessary to add metadata
    if(!create)return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function(it, create){
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return true;
    // not necessary to add metadata
    if(!create)return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function(it){
  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY:      META,
  NEED:     false,
  fastKey:  fastKey,
  getWeak:  getWeak,
  onFreeze: onFreeze
};
},{"./_fails":64,"./_has":67,"./_is-object":75,"./_object-dp":88,"./_uid":116}],85:[function(require,module,exports){
var global    = require('./_global')
  , macrotask = require('./_task').set
  , Observer  = global.MutationObserver || global.WebKitMutationObserver
  , process   = global.process
  , Promise   = global.Promise
  , isNode    = require('./_cof')(process) == 'process';

module.exports = function(){
  var head, last, notify;

  var flush = function(){
    var parent, fn;
    if(isNode && (parent = process.domain))parent.exit();
    while(head){
      fn   = head.fn;
      head = head.next;
      try {
        fn();
      } catch(e){
        if(head)notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if(parent)parent.enter();
  };

  // Node.js
  if(isNode){
    notify = function(){
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if(Observer){
    var toggle = true
      , node   = document.createTextNode('');
    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
    notify = function(){
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if(Promise && Promise.resolve){
    var promise = Promise.resolve();
    notify = function(){
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function(){
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function(fn){
    var task = {fn: fn, next: undefined};
    if(last)last.next = task;
    if(!head){
      head = task;
      notify();
    } last = task;
  };
};
},{"./_cof":50,"./_global":66,"./_task":109}],86:[function(require,module,exports){
'use strict';
// 19.1.2.1 Object.assign(target, source, ...)
var getKeys  = require('./_object-keys')
  , gOPS     = require('./_object-gops')
  , pIE      = require('./_object-pie')
  , toObject = require('./_to-object')
  , IObject  = require('./_iobject')
  , $assign  = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || require('./_fails')(function(){
  var A = {}
    , B = {}
    , S = Symbol()
    , K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function(k){ B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
  var T     = toObject(target)
    , aLen  = arguments.length
    , index = 1
    , getSymbols = gOPS.f
    , isEnum     = pIE.f;
  while(aLen > index){
    var S      = IObject(arguments[index++])
      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
      , length = keys.length
      , j      = 0
      , key;
    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
  } return T;
} : $assign;
},{"./_fails":64,"./_iobject":72,"./_object-gops":93,"./_object-keys":96,"./_object-pie":97,"./_to-object":114}],87:[function(require,module,exports){
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject    = require('./_an-object')
  , dPs         = require('./_object-dps')
  , enumBugKeys = require('./_enum-bug-keys')
  , IE_PROTO    = require('./_shared-key')('IE_PROTO')
  , Empty       = function(){ /* empty */ }
  , PROTOTYPE   = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function(){
  // Thrash, waste and sodomy: IE GC bug
  var iframe = require('./_dom-create')('iframe')
    , i      = enumBugKeys.length
    , lt     = '<'
    , gt     = '>'
    , iframeDocument;
  iframe.style.display = 'none';
  require('./_html').appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties){
  var result;
  if(O !== null){
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty;
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

},{"./_an-object":43,"./_dom-create":60,"./_enum-bug-keys":61,"./_html":69,"./_object-dps":89,"./_shared-key":105}],88:[function(require,module,exports){
var anObject       = require('./_an-object')
  , IE8_DOM_DEFINE = require('./_ie8-dom-define')
  , toPrimitive    = require('./_to-primitive')
  , dP             = Object.defineProperty;

exports.f = require('./_descriptors') ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};
},{"./_an-object":43,"./_descriptors":59,"./_ie8-dom-define":70,"./_to-primitive":115}],89:[function(require,module,exports){
var dP       = require('./_object-dp')
  , anObject = require('./_an-object')
  , getKeys  = require('./_object-keys');

module.exports = require('./_descriptors') ? Object.defineProperties : function defineProperties(O, Properties){
  anObject(O);
  var keys   = getKeys(Properties)
    , length = keys.length
    , i = 0
    , P;
  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
  return O;
};
},{"./_an-object":43,"./_descriptors":59,"./_object-dp":88,"./_object-keys":96}],90:[function(require,module,exports){
var pIE            = require('./_object-pie')
  , createDesc     = require('./_property-desc')
  , toIObject      = require('./_to-iobject')
  , toPrimitive    = require('./_to-primitive')
  , has            = require('./_has')
  , IE8_DOM_DEFINE = require('./_ie8-dom-define')
  , gOPD           = Object.getOwnPropertyDescriptor;

exports.f = require('./_descriptors') ? gOPD : function getOwnPropertyDescriptor(O, P){
  O = toIObject(O);
  P = toPrimitive(P, true);
  if(IE8_DOM_DEFINE)try {
    return gOPD(O, P);
  } catch(e){ /* empty */ }
  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
};
},{"./_descriptors":59,"./_has":67,"./_ie8-dom-define":70,"./_object-pie":97,"./_property-desc":99,"./_to-iobject":112,"./_to-primitive":115}],91:[function(require,module,exports){
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = require('./_to-iobject')
  , gOPN      = require('./_object-gopn').f
  , toString  = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function(it){
  try {
    return gOPN(it);
  } catch(e){
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it){
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};

},{"./_object-gopn":92,"./_to-iobject":112}],92:[function(require,module,exports){
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys      = require('./_object-keys-internal')
  , hiddenKeys = require('./_enum-bug-keys').concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
  return $keys(O, hiddenKeys);
};
},{"./_enum-bug-keys":61,"./_object-keys-internal":95}],93:[function(require,module,exports){
exports.f = Object.getOwnPropertySymbols;
},{}],94:[function(require,module,exports){
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has         = require('./_has')
  , toObject    = require('./_to-object')
  , IE_PROTO    = require('./_shared-key')('IE_PROTO')
  , ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function(O){
  O = toObject(O);
  if(has(O, IE_PROTO))return O[IE_PROTO];
  if(typeof O.constructor == 'function' && O instanceof O.constructor){
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};
},{"./_has":67,"./_shared-key":105,"./_to-object":114}],95:[function(require,module,exports){
var has          = require('./_has')
  , toIObject    = require('./_to-iobject')
  , arrayIndexOf = require('./_array-includes')(false)
  , IE_PROTO     = require('./_shared-key')('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};
},{"./_array-includes":45,"./_has":67,"./_shared-key":105,"./_to-iobject":112}],96:[function(require,module,exports){
// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = require('./_object-keys-internal')
  , enumBugKeys = require('./_enum-bug-keys');

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};
},{"./_enum-bug-keys":61,"./_object-keys-internal":95}],97:[function(require,module,exports){
exports.f = {}.propertyIsEnumerable;
},{}],98:[function(require,module,exports){
// most Object methods by ES6 should accept primitives
var $export = require('./_export')
  , core    = require('./_core')
  , fails   = require('./_fails');
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};
},{"./_core":55,"./_export":63,"./_fails":64}],99:[function(require,module,exports){
module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};
},{}],100:[function(require,module,exports){
var hide = require('./_hide');
module.exports = function(target, src, safe){
  for(var key in src){
    if(safe && target[key])target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};
},{"./_hide":68}],101:[function(require,module,exports){
module.exports = require('./_hide');
},{"./_hide":68}],102:[function(require,module,exports){
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = require('./_is-object')
  , anObject = require('./_an-object');
var check = function(O, proto){
  anObject(O);
  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function(test, buggy, set){
      try {
        set = require('./_ctx')(Function.call, require('./_object-gopd').f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch(e){ buggy = true; }
      return function setPrototypeOf(O, proto){
        check(O, proto);
        if(buggy)O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};
},{"./_an-object":43,"./_ctx":57,"./_is-object":75,"./_object-gopd":90}],103:[function(require,module,exports){
'use strict';
var global      = require('./_global')
  , core        = require('./_core')
  , dP          = require('./_object-dp')
  , DESCRIPTORS = require('./_descriptors')
  , SPECIES     = require('./_wks')('species');

module.exports = function(KEY){
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
    configurable: true,
    get: function(){ return this; }
  });
};
},{"./_core":55,"./_descriptors":59,"./_global":66,"./_object-dp":88,"./_wks":119}],104:[function(require,module,exports){
var def = require('./_object-dp').f
  , has = require('./_has')
  , TAG = require('./_wks')('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};
},{"./_has":67,"./_object-dp":88,"./_wks":119}],105:[function(require,module,exports){
var shared = require('./_shared')('keys')
  , uid    = require('./_uid');
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};
},{"./_shared":106,"./_uid":116}],106:[function(require,module,exports){
var global = require('./_global')
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};
},{"./_global":66}],107:[function(require,module,exports){
// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject  = require('./_an-object')
  , aFunction = require('./_a-function')
  , SPECIES   = require('./_wks')('species');
module.exports = function(O, D){
  var C = anObject(O).constructor, S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};
},{"./_a-function":40,"./_an-object":43,"./_wks":119}],108:[function(require,module,exports){
var toInteger = require('./_to-integer')
  , defined   = require('./_defined');
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};
},{"./_defined":58,"./_to-integer":111}],109:[function(require,module,exports){
var ctx                = require('./_ctx')
  , invoke             = require('./_invoke')
  , html               = require('./_html')
  , cel                = require('./_dom-create')
  , global             = require('./_global')
  , process            = global.process
  , setTask            = global.setImmediate
  , clearTask          = global.clearImmediate
  , MessageChannel     = global.MessageChannel
  , counter            = 0
  , queue              = {}
  , ONREADYSTATECHANGE = 'onreadystatechange'
  , defer, channel, port;
var run = function(){
  var id = +this;
  if(queue.hasOwnProperty(id)){
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function(event){
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if(!setTask || !clearTask){
  setTask = function setImmediate(fn){
    var args = [], i = 1;
    while(arguments.length > i)args.push(arguments[i++]);
    queue[++counter] = function(){
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id){
    delete queue[id];
  };
  // Node.js 0.8-
  if(require('./_cof')(process) == 'process'){
    defer = function(id){
      process.nextTick(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if(MessageChannel){
    channel = new MessageChannel;
    port    = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
    defer = function(id){
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if(ONREADYSTATECHANGE in cel('script')){
    defer = function(id){
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function(id){
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set:   setTask,
  clear: clearTask
};
},{"./_cof":50,"./_ctx":57,"./_dom-create":60,"./_global":66,"./_html":69,"./_invoke":71}],110:[function(require,module,exports){
var toInteger = require('./_to-integer')
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};
},{"./_to-integer":111}],111:[function(require,module,exports){
// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};
},{}],112:[function(require,module,exports){
// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = require('./_iobject')
  , defined = require('./_defined');
module.exports = function(it){
  return IObject(defined(it));
};
},{"./_defined":58,"./_iobject":72}],113:[function(require,module,exports){
// 7.1.15 ToLength
var toInteger = require('./_to-integer')
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};
},{"./_to-integer":111}],114:[function(require,module,exports){
// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function(it){
  return Object(defined(it));
};
},{"./_defined":58}],115:[function(require,module,exports){
// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = require('./_is-object');
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};
},{"./_is-object":75}],116:[function(require,module,exports){
var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};
},{}],117:[function(require,module,exports){
var global         = require('./_global')
  , core           = require('./_core')
  , LIBRARY        = require('./_library')
  , wksExt         = require('./_wks-ext')
  , defineProperty = require('./_object-dp').f;
module.exports = function(name){
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
};
},{"./_core":55,"./_global":66,"./_library":83,"./_object-dp":88,"./_wks-ext":118}],118:[function(require,module,exports){
exports.f = require('./_wks');
},{"./_wks":119}],119:[function(require,module,exports){
var store      = require('./_shared')('wks')
  , uid        = require('./_uid')
  , Symbol     = require('./_global').Symbol
  , USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function(name){
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;
},{"./_global":66,"./_shared":106,"./_uid":116}],120:[function(require,module,exports){
var classof   = require('./_classof')
  , ITERATOR  = require('./_wks')('iterator')
  , Iterators = require('./_iterators');
module.exports = require('./_core').getIteratorMethod = function(it){
  if(it != undefined)return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};
},{"./_classof":49,"./_core":55,"./_iterators":81,"./_wks":119}],121:[function(require,module,exports){
var anObject = require('./_an-object')
  , get      = require('./core.get-iterator-method');
module.exports = require('./_core').getIterator = function(it){
  var iterFn = get(it);
  if(typeof iterFn != 'function')throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};
},{"./_an-object":43,"./_core":55,"./core.get-iterator-method":120}],122:[function(require,module,exports){
'use strict';
var ctx            = require('./_ctx')
  , $export        = require('./_export')
  , toObject       = require('./_to-object')
  , call           = require('./_iter-call')
  , isArrayIter    = require('./_is-array-iter')
  , toLength       = require('./_to-length')
  , createProperty = require('./_create-property')
  , getIterFn      = require('./core.get-iterator-method');

$export($export.S + $export.F * !require('./_iter-detect')(function(iter){ Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
    var O       = toObject(arrayLike)
      , C       = typeof this == 'function' ? this : Array
      , aLen    = arguments.length
      , mapfn   = aLen > 1 ? arguments[1] : undefined
      , mapping = mapfn !== undefined
      , index   = 0
      , iterFn  = getIterFn(O)
      , length, result, step, iterator;
    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for(result = new C(length); length > index; index++){
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});

},{"./_create-property":56,"./_ctx":57,"./_export":63,"./_is-array-iter":73,"./_iter-call":76,"./_iter-detect":79,"./_to-length":113,"./_to-object":114,"./core.get-iterator-method":120}],123:[function(require,module,exports){
'use strict';
var addToUnscopables = require('./_add-to-unscopables')
  , step             = require('./_iter-step')
  , Iterators        = require('./_iterators')
  , toIObject        = require('./_to-iobject');

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = require('./_iter-define')(Array, 'Array', function(iterated, kind){
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , kind  = this._k
    , index = this._i++;
  if(!O || index >= O.length){
    this._t = undefined;
    return step(1);
  }
  if(kind == 'keys'  )return step(0, index);
  if(kind == 'values')return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');
},{"./_add-to-unscopables":41,"./_iter-define":78,"./_iter-step":80,"./_iterators":81,"./_to-iobject":112}],124:[function(require,module,exports){
'use strict';
var strong = require('./_collection-strong');

// 23.1 Map Objects
module.exports = require('./_collection')('Map', function(get){
  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key){
    var entry = strong.getEntry(this, key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value){
    return strong.def(this, key === 0 ? 0 : key, value);
  }
}, strong, true);
},{"./_collection":54,"./_collection-strong":51}],125:[function(require,module,exports){
// 19.1.3.1 Object.assign(target, source)
var $export = require('./_export');

$export($export.S + $export.F, 'Object', {assign: require('./_object-assign')});
},{"./_export":63,"./_object-assign":86}],126:[function(require,module,exports){
var $export = require('./_export')
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', {create: require('./_object-create')});
},{"./_export":63,"./_object-create":87}],127:[function(require,module,exports){
var $export = require('./_export');
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !require('./_descriptors'), 'Object', {defineProperty: require('./_object-dp').f});
},{"./_descriptors":59,"./_export":63,"./_object-dp":88}],128:[function(require,module,exports){
// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject                 = require('./_to-iobject')
  , $getOwnPropertyDescriptor = require('./_object-gopd').f;

require('./_object-sap')('getOwnPropertyDescriptor', function(){
  return function getOwnPropertyDescriptor(it, key){
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});
},{"./_object-gopd":90,"./_object-sap":98,"./_to-iobject":112}],129:[function(require,module,exports){
// 19.1.2.9 Object.getPrototypeOf(O)
var toObject        = require('./_to-object')
  , $getPrototypeOf = require('./_object-gpo');

require('./_object-sap')('getPrototypeOf', function(){
  return function getPrototypeOf(it){
    return $getPrototypeOf(toObject(it));
  };
});
},{"./_object-gpo":94,"./_object-sap":98,"./_to-object":114}],130:[function(require,module,exports){
// 19.1.2.14 Object.keys(O)
var toObject = require('./_to-object')
  , $keys    = require('./_object-keys');

require('./_object-sap')('keys', function(){
  return function keys(it){
    return $keys(toObject(it));
  };
});
},{"./_object-keys":96,"./_object-sap":98,"./_to-object":114}],131:[function(require,module,exports){
// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = require('./_export');
$export($export.S, 'Object', {setPrototypeOf: require('./_set-proto').set});
},{"./_export":63,"./_set-proto":102}],132:[function(require,module,exports){

},{}],133:[function(require,module,exports){
'use strict';
var LIBRARY            = require('./_library')
  , global             = require('./_global')
  , ctx                = require('./_ctx')
  , classof            = require('./_classof')
  , $export            = require('./_export')
  , isObject           = require('./_is-object')
  , aFunction          = require('./_a-function')
  , anInstance         = require('./_an-instance')
  , forOf              = require('./_for-of')
  , speciesConstructor = require('./_species-constructor')
  , task               = require('./_task').set
  , microtask          = require('./_microtask')()
  , PROMISE            = 'Promise'
  , TypeError          = global.TypeError
  , process            = global.process
  , $Promise           = global[PROMISE]
  , process            = global.process
  , isNode             = classof(process) == 'process'
  , empty              = function(){ /* empty */ }
  , Internal, GenericPromiseCapability, Wrapper;

var USE_NATIVE = !!function(){
  try {
    // correct subclassing with @@species support
    var promise     = $Promise.resolve(1)
      , FakePromise = (promise.constructor = {})[require('./_wks')('species')] = function(exec){ exec(empty, empty); };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch(e){ /* empty */ }
}();

// helpers
var sameConstructor = function(a, b){
  // with library wrapper special case
  return a === b || a === $Promise && b === Wrapper;
};
var isThenable = function(it){
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var newPromiseCapability = function(C){
  return sameConstructor($Promise, C)
    ? new PromiseCapability(C)
    : new GenericPromiseCapability(C);
};
var PromiseCapability = GenericPromiseCapability = function(C){
  var resolve, reject;
  this.promise = new C(function($$resolve, $$reject){
    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject  = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject  = aFunction(reject);
};
var perform = function(exec){
  try {
    exec();
  } catch(e){
    return {error: e};
  }
};
var notify = function(promise, isReject){
  if(promise._n)return;
  promise._n = true;
  var chain = promise._c;
  microtask(function(){
    var value = promise._v
      , ok    = promise._s == 1
      , i     = 0;
    var run = function(reaction){
      var handler = ok ? reaction.ok : reaction.fail
        , resolve = reaction.resolve
        , reject  = reaction.reject
        , domain  = reaction.domain
        , result, then;
      try {
        if(handler){
          if(!ok){
            if(promise._h == 2)onHandleUnhandled(promise);
            promise._h = 1;
          }
          if(handler === true)result = value;
          else {
            if(domain)domain.enter();
            result = handler(value);
            if(domain)domain.exit();
          }
          if(result === reaction.promise){
            reject(TypeError('Promise-chain cycle'));
          } else if(then = isThenable(result)){
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch(e){
        reject(e);
      }
    };
    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if(isReject && !promise._h)onUnhandled(promise);
  });
};
var onUnhandled = function(promise){
  task.call(global, function(){
    var value = promise._v
      , abrupt, handler, console;
    if(isUnhandled(promise)){
      abrupt = perform(function(){
        if(isNode){
          process.emit('unhandledRejection', value, promise);
        } else if(handler = global.onunhandledrejection){
          handler({promise: promise, reason: value});
        } else if((console = global.console) && console.error){
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if(abrupt)throw abrupt.error;
  });
};
var isUnhandled = function(promise){
  if(promise._h == 1)return false;
  var chain = promise._a || promise._c
    , i     = 0
    , reaction;
  while(chain.length > i){
    reaction = chain[i++];
    if(reaction.fail || !isUnhandled(reaction.promise))return false;
  } return true;
};
var onHandleUnhandled = function(promise){
  task.call(global, function(){
    var handler;
    if(isNode){
      process.emit('rejectionHandled', promise);
    } else if(handler = global.onrejectionhandled){
      handler({promise: promise, reason: promise._v});
    }
  });
};
var $reject = function(value){
  var promise = this;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if(!promise._a)promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function(value){
  var promise = this
    , then;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if(promise === value)throw TypeError("Promise can't be resolved itself");
    if(then = isThenable(value)){
      microtask(function(){
        var wrapper = {_w: promise, _d: false}; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch(e){
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch(e){
    $reject.call({_w: promise, _d: false}, e); // wrap
  }
};

// constructor polyfill
if(!USE_NATIVE){
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor){
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch(err){
      $reject.call(this, err);
    }
  };
  Internal = function Promise(executor){
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = require('./_redefine-all')($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected){
      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail   = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if(this._a)this._a.push(reaction);
      if(this._s)notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function(onRejected){
      return this.then(undefined, onRejected);
    }
  });
  PromiseCapability = function(){
    var promise  = new Internal;
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject  = ctx($reject, promise, 1);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
require('./_set-to-string-tag')($Promise, PROMISE);
require('./_set-species')(PROMISE);
Wrapper = require('./_core')[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r){
    var capability = newPromiseCapability(this)
      , $$reject   = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x){
    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
    var capability = newPromiseCapability(this)
      , $$resolve  = capability.resolve;
    $$resolve(x);
    return capability.promise;
  }
});
$export($export.S + $export.F * !(USE_NATIVE && require('./_iter-detect')(function(iter){
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , resolve    = capability.resolve
      , reject     = capability.reject;
    var abrupt = perform(function(){
      var values    = []
        , index     = 0
        , remaining = 1;
      forOf(iterable, false, function(promise){
        var $index        = index++
          , alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function(value){
          if(alreadyCalled)return;
          alreadyCalled  = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , reject     = capability.reject;
    var abrupt = perform(function(){
      forOf(iterable, false, function(promise){
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  }
});
},{"./_a-function":40,"./_an-instance":42,"./_classof":49,"./_core":55,"./_ctx":57,"./_export":63,"./_for-of":65,"./_global":66,"./_is-object":75,"./_iter-detect":79,"./_library":83,"./_microtask":85,"./_redefine-all":100,"./_set-species":103,"./_set-to-string-tag":104,"./_species-constructor":107,"./_task":109,"./_wks":119}],134:[function(require,module,exports){
'use strict';
var $at  = require('./_string-at')(true);

// 21.1.3.27 String.prototype[@@iterator]()
require('./_iter-define')(String, 'String', function(iterated){
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , index = this._i
    , point;
  if(index >= O.length)return {value: undefined, done: true};
  point = $at(O, index);
  this._i += point.length;
  return {value: point, done: false};
});
},{"./_iter-define":78,"./_string-at":108}],135:[function(require,module,exports){
'use strict';
// ECMAScript 6 symbols shim
var global         = require('./_global')
  , has            = require('./_has')
  , DESCRIPTORS    = require('./_descriptors')
  , $export        = require('./_export')
  , redefine       = require('./_redefine')
  , META           = require('./_meta').KEY
  , $fails         = require('./_fails')
  , shared         = require('./_shared')
  , setToStringTag = require('./_set-to-string-tag')
  , uid            = require('./_uid')
  , wks            = require('./_wks')
  , wksExt         = require('./_wks-ext')
  , wksDefine      = require('./_wks-define')
  , keyOf          = require('./_keyof')
  , enumKeys       = require('./_enum-keys')
  , isArray        = require('./_is-array')
  , anObject       = require('./_an-object')
  , toIObject      = require('./_to-iobject')
  , toPrimitive    = require('./_to-primitive')
  , createDesc     = require('./_property-desc')
  , _create        = require('./_object-create')
  , gOPNExt        = require('./_object-gopn-ext')
  , $GOPD          = require('./_object-gopd')
  , $DP            = require('./_object-dp')
  , $keys          = require('./_object-keys')
  , gOPD           = $GOPD.f
  , dP             = $DP.f
  , gOPN           = gOPNExt.f
  , $Symbol        = global.Symbol
  , $JSON          = global.JSON
  , _stringify     = $JSON && $JSON.stringify
  , PROTOTYPE      = 'prototype'
  , HIDDEN         = wks('_hidden')
  , TO_PRIMITIVE   = wks('toPrimitive')
  , isEnum         = {}.propertyIsEnumerable
  , SymbolRegistry = shared('symbol-registry')
  , AllSymbols     = shared('symbols')
  , OPSymbols      = shared('op-symbols')
  , ObjectProto    = Object[PROTOTYPE]
  , USE_NATIVE     = typeof $Symbol == 'function'
  , QObject        = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function(){
  return _create(dP({}, 'a', {
    get: function(){ return dP(this, 'a', {value: 7}).a; }
  })).a != 7;
}) ? function(it, key, D){
  var protoDesc = gOPD(ObjectProto, key);
  if(protoDesc)delete ObjectProto[key];
  dP(it, key, D);
  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function(tag){
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
  return typeof it == 'symbol';
} : function(it){
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D){
  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if(has(AllSymbols, key)){
    if(!D.enumerable){
      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
      D = _create(D, {enumerable: createDesc(0, false)});
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P){
  anObject(it);
  var keys = enumKeys(P = toIObject(P))
    , i    = 0
    , l = keys.length
    , key;
  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P){
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key){
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
  it  = toIObject(it);
  key = toPrimitive(key, true);
  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
  var D = gOPD(it, key);
  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it){
  var names  = gOPN(toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
  var IS_OP  = it === ObjectProto
    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if(!USE_NATIVE){
  $Symbol = function Symbol(){
    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function(value){
      if(this === ObjectProto)$set.call(OPSymbols, value);
      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f   = $defineProperty;
  require('./_object-gopn').f = gOPNExt.f = $getOwnPropertyNames;
  require('./_object-pie').f  = $propertyIsEnumerable;
  require('./_object-gops').f = $getOwnPropertySymbols;

  if(DESCRIPTORS && !require('./_library')){
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function(name){
    return wrap(wks(name));
  }
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});

for(var symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);

for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function(key){
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key){
    if(isSymbol(key))return keyOf(SymbolRegistry, key);
    throw TypeError(key + ' is not a symbol!');
  },
  useSetter: function(){ setter = true; },
  useSimple: function(){ setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it){
    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
    var args = [it]
      , i    = 1
      , replacer, $replacer;
    while(arguments.length > i)args.push(arguments[i++]);
    replacer = args[1];
    if(typeof replacer == 'function')$replacer = replacer;
    if($replacer || !isArray(replacer))replacer = function(key, value){
      if($replacer)value = $replacer.call(this, key, value);
      if(!isSymbol(value))return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || require('./_hide')($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);
},{"./_an-object":43,"./_descriptors":59,"./_enum-keys":62,"./_export":63,"./_fails":64,"./_global":66,"./_has":67,"./_hide":68,"./_is-array":74,"./_keyof":82,"./_library":83,"./_meta":84,"./_object-create":87,"./_object-dp":88,"./_object-gopd":90,"./_object-gopn":92,"./_object-gopn-ext":91,"./_object-gops":93,"./_object-keys":96,"./_object-pie":97,"./_property-desc":99,"./_redefine":101,"./_set-to-string-tag":104,"./_shared":106,"./_to-iobject":112,"./_to-primitive":115,"./_uid":116,"./_wks":119,"./_wks-define":117,"./_wks-ext":118}],136:[function(require,module,exports){
'use strict';
var each         = require('./_array-methods')(0)
  , redefine     = require('./_redefine')
  , meta         = require('./_meta')
  , assign       = require('./_object-assign')
  , weak         = require('./_collection-weak')
  , isObject     = require('./_is-object')
  , getWeak      = meta.getWeak
  , isExtensible = Object.isExtensible
  , uncaughtFrozenStore = weak.ufstore
  , tmp          = {}
  , InternalMap;

var wrapper = function(get){
  return function WeakMap(){
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key){
    if(isObject(key)){
      var data = getWeak(key);
      if(data === true)return uncaughtFrozenStore(this).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value){
    return weak.def(this, key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = require('./_collection')('WeakMap', wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if(new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7){
  InternalMap = weak.getConstructor(wrapper);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function(key){
    var proto  = $WeakMap.prototype
      , method = proto[key];
    redefine(proto, key, function(a, b){
      // store frozen objects on internal weakmap shim
      if(isObject(a) && !isExtensible(a)){
        if(!this._f)this._f = new InternalMap;
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}
},{"./_array-methods":46,"./_collection":54,"./_collection-weak":53,"./_is-object":75,"./_meta":84,"./_object-assign":86,"./_redefine":101}],137:[function(require,module,exports){
// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export  = require('./_export');

$export($export.P + $export.R, 'Map', {toJSON: require('./_collection-to-json')('Map')});
},{"./_collection-to-json":52,"./_export":63}],138:[function(require,module,exports){
require('./_wks-define')('asyncIterator');
},{"./_wks-define":117}],139:[function(require,module,exports){
require('./_wks-define')('observable');
},{"./_wks-define":117}],140:[function(require,module,exports){
require('./es6.array.iterator');
var global        = require('./_global')
  , hide          = require('./_hide')
  , Iterators     = require('./_iterators')
  , TO_STRING_TAG = require('./_wks')('toStringTag');

for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
  var NAME       = collections[i]
    , Collection = global[NAME]
    , proto      = Collection && Collection.prototype;
  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}
},{"./_global":66,"./_hide":68,"./_iterators":81,"./_wks":119,"./es6.array.iterator":123}],141:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getLogger = getLogger;
exports.setLogger = setLogger;
exports.log = log;
var _logger = null;

function getLogger() {
    return _logger;
}

function setLogger(value) {
    _logger = value;
}

function log(type, message) {
    if (_logger != null) {
        _logger(type, message);
    }
}
},{}],142:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    "TransportError": 0,
    "TimeoutError": 1
};
},{}],143:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _map = require("babel-runtime/core-js/map");

var _map2 = _interopRequireDefault(_map);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Events = function () {
    function Events() {
        (0, _classCallCheck3.default)(this, Events);

        this._events = new _map2.default();
    }

    (0, _createClass3.default)(Events, [{
        key: "on",
        value: function on(type, handler) {
            var _this = this;

            var currentHandlers = this._events.get(type) || [];
            var handlers = currentHandlers.concat([handler]);
            this._events.set(type, handlers);
            return function () {
                return _this.off(type, handler);
            };
        }
    }, {
        key: "off",
        value: function off(type, handler) {
            if (typeof handler !== "undefined") {
                if (this._events.has(type)) {
                    var currentHandlers = this._events.get(type);
                    this._events.set(type, currentHandlers.filter(function (item) {
                        return item !== handler;
                    }));
                }
            } else {
                this._events.delete(type);
            }
        }
    }, {
        key: "trigger",
        value: function trigger(type, obj) {
            for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
                args[_key - 2] = arguments[_key];
            }

            if (this._events.has(type)) {
                this._events.get(type).forEach(function (handler) {
                    return handler.call.apply(handler, [obj].concat(args));
                });
            }
        }
    }]);
    return Events;
}();

exports.default = Events;
},{"babel-runtime/core-js/map":4,"babel-runtime/helpers/classCallCheck":17,"babel-runtime/helpers/createClass":18}],144:[function(require,module,exports){
(function (process){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _Request = require('./Request');

var _Request2 = _interopRequireDefault(_Request);

var _ErrorTypes = require('./ErrorTypes');

var _ErrorTypes2 = _interopRequireDefault(_ErrorTypes);

var _TransportTypes = require('./TransportTypes');

var _TransportTypes2 = _interopRequireDefault(_TransportTypes);

var _ConsoleUtils = require('./ConsoleUtils');

var consoleUtils = _interopRequireWildcard(_ConsoleUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Pollymer = function () {
    function Pollymer() {
        (0, _classCallCheck3.default)(this, Pollymer);
    }

    (0, _createClass3.default)(Pollymer, null, [{
        key: 'logger',
        set: function set(value) {
            consoleUtils.setLogger(value);
        },
        get: function get() {
            consoleUtils.getLogger();
        }
    }]);
    return Pollymer;
}();

Pollymer.Request = _Request2.default;
Pollymer.ErrorTypes = _ErrorTypes2.default;
Pollymer.TransportTypes = _TransportTypes2.default;

if (process.env.NODE_ENV === 'development') {
    Pollymer.logger = function (type, message) {
        console.log('Pollymer: ' + type + ' - ' + message);
    };
}

exports.default = Pollymer;
}).call(this,require('_process'))
},{"./ConsoleUtils":141,"./ErrorTypes":142,"./Request":145,"./TransportTypes":146,"_process":148,"babel-runtime/helpers/classCallCheck":17,"babel-runtime/helpers/createClass":18}],145:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _TransportTypes = require('./TransportTypes');

var _TransportTypes2 = _interopRequireDefault(_TransportTypes);

var _ErrorTypes = require('./ErrorTypes');

var _ErrorTypes2 = _interopRequireDefault(_ErrorTypes);

var _Events = require('./Events');

var _Events2 = _interopRequireDefault(_Events);

var _ConsoleUtils = require('./ConsoleUtils');

var consoleUtilities = _interopRequireWildcard(_ConsoleUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Global object (window in browsers)

var global = typeof window !== 'undefined' ? window : undefined;

// Create one instance of an empty method to be used where necessary

var emptyMethod = function emptyMethod() {};

// Utility to determine whether an HTTP code should be treated as an error

var checkForErrorCode = function checkForErrorCode(codesStr, code) {
    var parts = codesStr.split(',');
    for (var i = 0; i < parts.length; i++) {
        var part = parts[i];
        var index = part.indexOf('-');
        if (index >= 0) {
            // part is a range
            var min = parseInt(part.substring(0, index), 10);
            var max = parseInt(part.substring(index + 1), 10);
            if (code >= min && code <= max) {
                return true;
            }
        } else {
            // part is a single value
            var val = parseInt(part, 10);
            if (code == val) {
                return true;
            }
        }
    }
    return false;
};

// Response Header Parsing

var parseResponseHeaders = function parseResponseHeaders(headerStr) {
    var headers = {};
    if (!headerStr) {
        return headers;
    }
    var headerPairs = headerStr.split('\r\n');
    for (var i = 0; i < headerPairs.length; i++) {
        var headerPair = headerPairs[i];
        // IE sometimes puts a newline at the start of header names
        if (headerPair[0] == '\n') {
            headerPair = headerPair.substring(1);
        }
        var index = headerPair.indexOf(': ');
        if (index > 0) {
            var key = headerPair.substring(0, index);
            headers[key] = headerPair.substring(index + 2);
        }
    }
    return headers;
};

// JSONP-related utility functions

var jsonpGuid = "D3DDFE2A-6E6D-47A7-8F3B-0A4A8E71A796";

var addJsonpScriptToDom = function addJsonpScriptToDom(src, scriptId) {
    var script = global.document.createElement("script");
    script.type = "text/javascript";
    script.id = scriptId;
    script.src = src;

    var head = global.document.getElementsByTagName("head")[0];
    head.appendChild(script);
};

var removeJsonpScriptFromDom = function removeJsonpScriptFromDom(scriptId) {
    var script = global.document.getElementById(scriptId);
    script.parentNode.removeChild(script);
};

// CORS detection

var corsAvailable = "withCredentials" in new global.XMLHttpRequest();

// Transport Selection

var sameOrigin = function sameOrigin(url) {
    var loc = global.location;
    var a = global.document.createElement('a');
    a.href = url;
    return !a.hostname || a.hostname == loc.hostname && a.port == loc.port && a.protocol == loc.protocol;
};

var chooseTransport = function chooseTransport(transportType, url) {
    var transport;
    if (transportType == _TransportTypes2.default.Auto) {
        if (corsAvailable || sameOrigin(url)) {
            transport = _TransportTypes2.default.Xhr;
        } else {
            transport = _TransportTypes2.default.Jsonp;
        }
    } else {
        switch (transportType) {
            case _TransportTypes2.default.Xhr:
                transport = _TransportTypes2.default.Xhr;
                break;
            case _TransportTypes2.default.Jsonp:
                transport = _TransportTypes2.default.Jsonp;
                break;
            default:
                transport = null;
        }
    }
    return transport;
};

// Pollymer.Request has callback members:
// on('finished', int code, object result, object headers)
// on('error', int reason)

var Request = function () {
    function Request() {
        (0, _classCallCheck3.default)(this, Request);

        this._events = new _Events2.default();
        this._tries = 0;
        this._delayNext = false;
        this._retryTime = 0;
        this._timer = null;
        this._jsonp = null;

        this._xhr = null;
        this._method = null;
        this._url = null;
        this._headers = null;
        this._body = null;
        this._transport = null;

        this.transport = _TransportTypes2.default.Auto;
        this.rawResponse = false;
        this.maxTries = 1;
        this.maxDelay = 1000;
        this.recurring = false;
        this.withCredentials = false;
        this.timeout = 60000;
        this.errorCodes = '500-599';

        this.lastRequest = null;

        if (arguments.length > 0) {
            var config = arguments[0];
            if ("transport" in config) {
                this.transport = config.transport;
            }
            if ("rawResponse" in config) {
                this.rawResponse = config.rawResponse;
            }
            if ("maxTries" in config) {
                this.maxTries = config.maxTries;
            }
            if ("maxDelay" in config) {
                this.maxDelay = config.maxDelay;
            }
            if ("recurring" in config) {
                this.recurring = config.recurring;
            }
            if ("withCredentials" in config) {
                this.withCredentials = config.withCredentials;
            }
            if ("timeout" in config) {
                this.timeout = config.timeout;
            }
            if ("errorCodes" in config) {
                this.errorCodes = config.errorCodes;
            }
        }
    }

    (0, _createClass3.default)(Request, [{
        key: 'start',
        value: function start(method, url, headers, body) {
            if (this._timer != null) {
                consoleUtilities.log("error", "start() called on a Request object that is currently running.");
                return;
            }

            this._method = method;
            this._url = url;
            this._headers = headers;
            this._body = body;
            this._start();
        }
    }, {
        key: '_start',
        value: function _start() {
            this._tries = 0;

            var delayTime;
            if (this._delayNext) {
                this._delayNext = false;
                delayTime = Math.floor(Math.random() * this.maxDelay);
                consoleUtilities.log("info", "polling again in " + delayTime + "ms");
            } else {
                delayTime = 0; // always queue the call, to prevent browser "busy"
            }

            this._initiate(delayTime);
        }
    }, {
        key: 'retry',
        value: function retry() {
            if (this._tries == 0) {
                consoleUtilities.log("error", "retry() called on a Request object that has never been started.");
                return;
            }
            if (this._timer != null) {
                consoleUtilities.log("error", "retry() called on a Request object that is currently running.");
                return;
            }
            this._retry();
        }
    }, {
        key: '_retry',
        value: function _retry() {
            if (this._tries === 1) {
                this._retryTime = 1;
            } else if (this._tries < 8) {
                this._retryTime = this._retryTime * 2;
            }

            var delayTime = this._retryTime * 1000;
            delayTime += Math.floor(Math.random() * this.maxDelay);
            consoleUtilities.log("info", "trying again in " + delayTime + "ms");

            this._initiate(delayTime);
        }
    }, {
        key: '_initiate',
        value: function _initiate(delayMsecs) {
            var self = this;
            self.lastRequest = null;
            self._timer = setTimeout(function () {
                self._startConnect();
            }, delayMsecs);
        }
    }, {
        key: '_startConnect',
        value: function _startConnect() {
            var self = this;
            this._timer = setTimeout(function () {
                self._timeout();
            }, this.timeout);

            this._tries++;

            var method = this._method;
            var url = typeof this._url == "function" ? this._url() : this._url;
            var headers = this._headers;
            var body = this._body;

            // Create a copy of the transport because we don't want
            // to give public access to it (changing it between now and
            // cleanup would be a no-no)
            this._transport = chooseTransport(this.transport, url);

            self.lastRequest = {
                method: method,
                uri: url,
                headers: headers,
                body: body,
                transport: this._transport
            };

            switch (this._transport) {
                case _TransportTypes2.default.Xhr:
                    consoleUtilities.log("info", "Using XHR transport.");
                    this._xhr = this._startXhr(method, url, headers, body);
                    break;
                case _TransportTypes2.default.Jsonp:
                    consoleUtilities.log("info", "Using JSONP transport.");
                    this._jsonp = this._startJsonp(method, url, headers, body);
                    break;
                default:
                    consoleUtilities.log("error", "Invalid transport.");
                    break;
            }
        }
    }, {
        key: '_cleanupConnect',
        value: function _cleanupConnect(abort) {
            clearTimeout(this._timer);
            this._timer = null;

            switch (this._transport) {
                case _TransportTypes2.default.Xhr:
                    consoleUtilities.log("info", "XHR cleanup");
                    this._cleanupXhr(this._xhr, abort);
                    this._xhr = null;
                    break;
                case _TransportTypes2.default.Jsonp:
                    consoleUtilities.log("info", "json-p " + this._jsonp.id + " cleanup");
                    this._cleanupJsonp(this._jsonp, abort);
                    this._jsonp = null;
                    break;
            }
        }
    }, {
        key: 'abort',
        value: function abort() {
            this._cleanupConnect(true);
        }
    }, {
        key: 'on',
        value: function on(type, handler) {
            return this._events.on(type, handler);
        }
    }, {
        key: 'off',
        value: function off(type, handler) {
            this._events.off(type, handler);
        }
    }, {
        key: '_startXhr',
        value: function _startXhr(method, url, headers, body) {
            var xhr = new global.XMLHttpRequest();

            // If header has Authorization, and cors is available, then set the
            // withCredentials flag.
            if (this.withCredentials && corsAvailable) {
                xhr.withCredentials = true;
            }

            var self = this;
            xhr.onreadystatechange = function () {
                self._xhrCallback();
            };
            xhr.open(method, url, true);

            for (var key in headers) {
                if (headers.hasOwnProperty(key)) {
                    xhr.setRequestHeader(key, headers[key]);
                }
            }

            xhr.send(body);

            consoleUtilities.log("info", "XHR start " + url);

            return xhr;
        }
    }, {
        key: '_cleanupXhr',
        value: function _cleanupXhr(xhr, abort) {
            if (xhr != null) {
                xhr.onreadystatechange = emptyMethod;
                if (abort) {
                    xhr.abort();
                }
            }
        }
    }, {
        key: '_xhrCallback',
        value: function _xhrCallback() {
            var xhr = this._xhr;
            if (xhr != null && xhr.readyState === 4) {
                consoleUtilities.log("info", "XHR finished");

                var code = xhr.status;
                var reason = xhr.statusText;
                var headers = parseResponseHeaders(xhr.getAllResponseHeaders());
                var body = xhr.responseText;

                this._handleResponse(code, reason, headers, body);
            }
        }
    }, {
        key: '_getJsonpCallbacks',
        value: function _getJsonpCallbacks() {
            // Jsonp mode means we are safe to use window
            // (Jsonp only makes sense in the context of a DOM anyway)
            if (!(jsonpGuid in global)) {
                global[jsonpGuid] = {
                    id: 0,
                    requests: {},
                    getJsonpCallback: function getJsonpCallback(id) {
                        var cb;
                        var requests = this.requests;
                        if (id in this.requests) {
                            cb = function cb(result) {
                                requests[id]._jsonpCallback(result);
                            };
                        } else {
                            consoleUtilities.log("info", "no callback with id " + id);
                            cb = emptyMethod;
                        }
                        return cb;
                    },
                    addJsonpCallback: function addJsonpCallback(id, obj) {
                        this.requests[id] = obj;
                    },
                    removeJsonpCallback: function removeJsonpCallback(id) {
                        delete this.requests[id];
                    },
                    newCallbackInfo: function newCallbackInfo() {
                        var callbackInfo = {
                            id: "cb-" + this.id,
                            scriptId: "pd-jsonp-script-" + this.id
                        };
                        this.id++;
                        return callbackInfo;
                    }
                };
            }

            return global[jsonpGuid];
        }
    }, {
        key: '_startJsonp',
        value: function _startJsonp(method, url, headers, body) {
            var jsonpCallbacks = this._getJsonpCallbacks();
            var jsonp = jsonpCallbacks.newCallbackInfo();

            var paramList = ["callback=" + encodeURIComponent('window["' + jsonpGuid + '"].getJsonpCallback("' + jsonp.id + '")')];

            if (method != "GET") {
                paramList.push("_method=" + encodeURIComponent(method));
            }
            if (headers) {
                paramList.push("_headers=" + encodeURIComponent((0, _stringify2.default)(headers)));
            }
            if (body) {
                paramList.push("_body=" + encodeURIComponent(body));
            }
            var params = paramList.join("&");

            var src = url.indexOf("?") != -1 ? url + "&" + params : url + "?" + params;

            jsonpCallbacks.addJsonpCallback(jsonp.id, this);
            addJsonpScriptToDom(src, jsonp.scriptId);

            consoleUtilities.log("info", "json-p start " + jsonp.id + " " + src);

            return jsonp;
        }
    }, {
        key: '_cleanupJsonp',
        value: function _cleanupJsonp(jsonp, abort) {
            var jsonpCallbacks = this._getJsonpCallbacks();

            if (jsonp != null) {
                jsonpCallbacks.removeJsonpCallback(jsonp.id);
                removeJsonpScriptFromDom(jsonp.scriptId);
            }
        }
    }, {
        key: '_jsonpCallback',
        value: function _jsonpCallback(result) {
            consoleUtilities.log("info", "json-p " + this._jsonp.id + " finished");

            var code = "code" in result ? result.code : 0;
            var reason = "reason" in result ? result.reason : null;
            var headers = "headers" in result ? result.headers : {};
            var body = "body" in result ? result.body : null;

            this._handleResponse(code, reason, headers, body);
        }
    }, {
        key: '_handleResponse',
        value: function _handleResponse(code, reason, headers, body) {
            this._cleanupConnect();

            if ((code == 0 || checkForErrorCode(this.errorCodes, code)) && (this.maxTries == -1 || this._tries < this.maxTries)) {
                this._retry();
            } else {
                if (code > 0) {
                    var result;
                    if (this.rawResponse) {
                        result = body;
                    } else {
                        try {
                            result = JSON.parse(body);
                        } catch (e) {
                            result = body;
                        }
                    }
                    this._finished(code, result, headers);
                    if (this.recurring && code >= 200 && code < 300) {
                        this._start();
                    }
                } else {
                    this._error(_ErrorTypes2.default.TransportError);
                }
            }
        }
    }, {
        key: '_timeout',
        value: function _timeout() {
            this._cleanupConnect(true);

            if (this.maxTries == -1 || this._tries < this.maxTries) {
                this._retry();
            } else {
                this._error(_ErrorTypes2.default.TimeoutError);
            }
        }
    }, {
        key: '_finished',
        value: function _finished(code, result, headers) {
            this._delayNext = true;
            this._events.trigger('finished', this, code, result, headers);
        }
    }, {
        key: '_error',
        value: function _error(reason) {
            this._delayNext = true;
            this._events.trigger('error', this, reason);
        }
    }]);
    return Request;
}();

exports.default = Request;
},{"./ConsoleUtils":141,"./ErrorTypes":142,"./Events":143,"./TransportTypes":146,"babel-runtime/core-js/json/stringify":3,"babel-runtime/helpers/classCallCheck":17,"babel-runtime/helpers/createClass":18}],146:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    "Auto": 0,
    "Xhr": 1,
    "Jsonp": 2
};
},{}],147:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Pollymer = require("./Pollymer");

Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Pollymer).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
},{"./Pollymer":144}],148:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],149:[function(require,module,exports){
(function (global){
// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g =
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this;

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = require("./runtime");

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./runtime":150}],150:[function(require,module,exports){
(function (process,global){
/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var hasOwn = Object.prototype.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided, then outerFn.prototype instanceof Generator.
    var generator = Object.create((outerFn || Generator).prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `value instanceof AwaitArgument` to determine if the yielded value is
  // meant to be awaited. Some may consider the name of this method too
  // cutesy, but they are curmudgeons.
  runtime.awrap = function(arg) {
    return new AwaitArgument(arg);
  };

  function AwaitArgument(arg) {
    this.arg = arg;
  }

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value instanceof AwaitArgument) {
          return Promise.resolve(value.arg).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof process === "object" && process.domain) {
      invoke = process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          if (method === "return" ||
              (method === "throw" && delegate.iterator[method] === undefined)) {
            // A return or throw (when the delegate iterator has no throw
            // method) always terminates the yield* loop.
            context.delegate = null;

            // If the delegate iterator has a return method, give it a
            // chance to clean up.
            var returnMethod = delegate.iterator["return"];
            if (returnMethod) {
              var record = tryCatch(returnMethod, delegate.iterator, arg);
              if (record.type === "throw") {
                // If the return method threw an exception, let that
                // exception prevail over the original return or throw.
                method = "throw";
                arg = record.arg;
                continue;
              }
            }

            if (method === "return") {
              // Continue with the outer return, now that the delegate
              // iterator has been terminated.
              continue;
            }
          }

          var record = tryCatch(
            delegate.iterator[method],
            delegate.iterator,
            arg
          );

          if (record.type === "throw") {
            context.delegate = null;

            // Like returning generator.throw(uncaught), but without the
            // overhead of an extra function call.
            method = "throw";
            arg = record.arg;
            continue;
          }

          // Delegate generator ran and handled its own exceptions so
          // regardless of what the method was, we continue as if it is
          // "next" with an undefined arg.
          method = "next";
          arg = undefined;

          var info = record.arg;
          if (info.done) {
            context[delegate.resultName] = info.value;
            context.next = delegate.nextLoc;
          } else {
            state = GenStateSuspendedYield;
            return info;
          }

          context.delegate = null;
        }

        if (method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = arg;

        } else if (method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw arg;
          }

          if (context.dispatchException(arg)) {
            // If the dispatched exception was caught by a catch block,
            // then let that catch block handle the exception normally.
            method = "next";
            arg = undefined;
          }

        } else if (method === "return") {
          context.abrupt("return", arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          var info = {
            value: record.arg,
            done: context.done
          };

          if (record.arg === ContinueSentinel) {
            if (context.delegate && method === "next") {
              // Deliberately forget the last sent value so that we don't
              // accidentally pass it on to the delegate.
              arg = undefined;
            }
          } else {
            return info;
          }

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(arg) call above.
          method = "throw";
          arg = record.arg;
        }
      }
    };
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp[toStringTagSymbol] = "Generator";

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;
        return !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.next = finallyEntry.finallyLoc;
      } else {
        this.complete(record);
      }

      return ContinueSentinel;
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = record.arg;
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"_process":148}],151:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var ErrorEnumValue = {
    "None": 0,
    "Disconnect": 1,
    "Timeout": 2
};

exports.default = ErrorEnumValue;
},{}],152:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Events = function () {
    function Events(ctx) {
        (0, _classCallCheck3.default)(this, Events);

        this._events = {};
        this._ctx = ctx;
    }

    (0, _createClass3.default)(Events, [{
        key: "_getHandlersForType",
        value: function _getHandlersForType(type) {
            if (!(type in this._events)) {
                this._events[type] = [];
            }
            return this._events[type];
        }
    }, {
        key: "on",
        value: function on(type, handler) {
            var handlers = this._getHandlersForType(type);
            handlers.push(handler);
        }
    }, {
        key: "off",
        value: function off(type, handler) {
            if (handler != null) {
                var handlers = this._getHandlersForType(type);
                (0, _utils.removeFromArray)(handlers, handler);
            } else {
                delete this._events[type];
            }
        }
    }, {
        key: "trigger",
        value: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(type) {
                var _this = this;

                for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                    args[_key - 1] = arguments[_key];
                }

                var handlers, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, _ret;

                return _regenerator2.default.wrap(function _callee2$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                handlers = this._getHandlersForType(type).slice();
                                _iteratorNormalCompletion = true;
                                _didIteratorError = false;
                                _iteratorError = undefined;
                                _context3.prev = 4;
                                _loop = _regenerator2.default.mark(function _loop() {
                                    var handler, result;
                                    return _regenerator2.default.wrap(function _loop$(_context2) {
                                        while (1) {
                                            switch (_context2.prev = _context2.next) {
                                                case 0:
                                                    handler = _step.value;
                                                    _context2.next = 3;
                                                    return new _promise2.default(function () {
                                                        var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(resolve, reject) {
                                                            var isAsync, handlerResult;
                                                            return _regenerator2.default.wrap(function _callee$(_context) {
                                                                while (1) {
                                                                    switch (_context.prev = _context.next) {
                                                                        case 0:
                                                                            _context.prev = 0;
                                                                            isAsync = false;


                                                                            _this._ctx.async = function () {
                                                                                isAsync = true;
                                                                                return function () {
                                                                                    var continueLoop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                                                                                    resolve(continueLoop);
                                                                                };
                                                                            };

                                                                            _context.next = 5;
                                                                            return _promise2.default.resolve(handler.call.apply(handler, [_this._ctx].concat(args)));

                                                                        case 5:
                                                                            handlerResult = _context.sent;


                                                                            delete _this._ctx.async;

                                                                            if (isAsync) {
                                                                                // We don't resolve the promise now, but wait til the
                                                                                // thing above is called.
                                                                            } else {
                                                                                resolve(handlerResult);
                                                                            }

                                                                            _context.next = 13;
                                                                            break;

                                                                        case 10:
                                                                            _context.prev = 10;
                                                                            _context.t0 = _context["catch"](0);


                                                                            reject(_context.t0);

                                                                        case 13:
                                                                        case "end":
                                                                            return _context.stop();
                                                                    }
                                                                }
                                                            }, _callee, _this, [[0, 10]]);
                                                        }));

                                                        return function (_x3, _x4) {
                                                            return _ref2.apply(this, arguments);
                                                        };
                                                    }());

                                                case 3:
                                                    result = _context2.sent;

                                                    if (!(typeof result !== "undefined" && !result)) {
                                                        _context2.next = 6;
                                                        break;
                                                    }

                                                    return _context2.abrupt("return", "break");

                                                case 6:
                                                case "end":
                                                    return _context2.stop();
                                            }
                                        }
                                    }, _loop, _this);
                                });
                                _iterator = (0, _getIterator3.default)(handlers);

                            case 7:
                                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                                    _context3.next = 15;
                                    break;
                                }

                                return _context3.delegateYield(_loop(), "t0", 9);

                            case 9:
                                _ret = _context3.t0;

                                if (!(_ret === "break")) {
                                    _context3.next = 12;
                                    break;
                                }

                                return _context3.abrupt("break", 15);

                            case 12:
                                _iteratorNormalCompletion = true;
                                _context3.next = 7;
                                break;

                            case 15:
                                _context3.next = 21;
                                break;

                            case 17:
                                _context3.prev = 17;
                                _context3.t1 = _context3["catch"](4);
                                _didIteratorError = true;
                                _iteratorError = _context3.t1;

                            case 21:
                                _context3.prev = 21;
                                _context3.prev = 22;

                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }

                            case 24:
                                _context3.prev = 24;

                                if (!_didIteratorError) {
                                    _context3.next = 27;
                                    break;
                                }

                                throw _iteratorError;

                            case 27:
                                return _context3.finish(24);

                            case 28:
                                return _context3.finish(21);

                            case 29:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee2, this, [[4, 17, 21, 29], [22,, 24, 28]]);
            }));

            function trigger(_x, _x2) {
                return _ref.apply(this, arguments);
            }

            return trigger;
        }()
    }]);
    return Events;
}();

exports.default = Events;
},{"./utils":157,"babel-runtime/core-js/get-iterator":2,"babel-runtime/core-js/promise":12,"babel-runtime/helpers/asyncToGenerator":16,"babel-runtime/helpers/classCallCheck":17,"babel-runtime/helpers/createClass":18,"babel-runtime/regenerator":24}],153:[function(require,module,exports){
(function (process){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _utils = require("./utils");

var _browserDetection = require("./browserDetection");

var _Events = require("./Events");

var _Events2 = _interopRequireDefault(_Events);

var _ErrorEnumValue = require("./ErrorEnumValue");

var _ErrorEnumValue2 = _interopRequireDefault(_ErrorEnumValue);

var _formatters = require("./formatters");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function defaultCreateSocket(url, protocols) {
    if (!WebSockHop.isAvailable()) {
        throw "WebSockHop cannot be instantiated because one or more validity checks failed.";
    }
    return protocols != null ? new WebSocket(url, protocols) : new WebSocket(url);
}

function extractProtocolsFromOptions() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var protocol = _ref.protocol;
    var protocols = _ref.protocols;

    if (Array.isArray(protocols)) {
        return protocols;
    }

    if (typeof protocols === "string" || protocols instanceof String) {
        return [protocols];
    }

    if (typeof protocol === "string" || protocol instanceof String) {
        return [protocol];
    }

    return null;
}

var WebSockHop = function () {
    function WebSockHop(url, opts) {
        (0, _classCallCheck3.default)(this, WebSockHop);

        var protocols = extractProtocolsFromOptions(opts);

        var combinedOptions = (0, _assign2.default)({}, opts, protocols != null ? { protocols: protocols } : null);

        this._opts = combinedOptions;

        this.socket = null;
        this._url = url;
        this._events = new _Events2.default(this);
        this._timer = null;
        this._tries = 0;
        this._aborted = false;
        this._closing = false;
        this.formatter = null;

        this.connectionTimeoutMsecs = 10000; // 10 seconds default connection timeout

        this._pingTimer = null;
        this._lastSentPing = null;
        this._lastReceivedPongId = 0;
        this.pingIntervalMsecs = 60000; // 60 seconds default ping timeout
        this.pingResponseTimeoutMsecs = 10000; // 10 seconds default ping response timeout

        this.defaultRequestTimeoutMsecs = null; // Unless specified, request() calls use this value for timeout
        this.defaultDisconnectOnRequestTimeout = false; // If specified, request "timeout" events will handle as though socket was dropped

        this.protocol = null; // This will eventually hold the protocol that we successfully connected with

        this._attemptConnect();
    }

    (0, _createClass3.default)(WebSockHop, [{
        key: "_attemptConnect",
        value: function _attemptConnect() {
            var _this = this;

            if (!this._timer) {
                var delay = 0;
                if (this._tries > 0) {
                    var timeCap = 1 << Math.min(6, this._tries - 1);
                    delay = timeCap * 1000 + Math.floor(Math.random() * 1000);
                    WebSockHop.log("info", "Trying again in " + delay + "ms");
                }
                this._tries = this._tries + 1;

                this._timer = setTimeout((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _this._timer = null;
                                    _context.next = 3;
                                    return _this._start();

                                case 3:
                                case "end":
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this);
                })), delay);
            }
        }
    }, {
        key: "_abortConnect",
        value: function _abortConnect() {
            if (this._timer) {
                clearTimeout(this._timer);
                this._timer = null;
            }
            this._aborted = true;
        }
    }, {
        key: "_raiseEvent",
        value: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(event) {
                var _events;

                for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                    args[_key - 1] = arguments[_key];
                }

                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                WebSockHop.log("info", event + " event start");
                                _context2.next = 3;
                                return (_events = this._events).trigger.apply(_events, [event].concat(args));

                            case 3:
                                WebSockHop.log("info", event + " event end");

                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function _raiseEvent(_x2, _x3) {
                return _ref3.apply(this, arguments);
            }

            return _raiseEvent;
        }()
    }, {
        key: "_start",
        value: function () {
            var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
                var _this2 = this;

                return _regenerator2.default.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                if (this.formatter == null) {
                                    WebSockHop.log("info", "No message formatter had been specified, creating a StringFormatter instance as formatter.");
                                    this.formatter = new _formatters.StringFormatter();
                                }
                                _context5.next = 3;
                                return this._raiseEvent("opening");

                            case 3:
                                if (!this._aborted) {
                                    (function () {
                                        var _opts = _this2._opts;
                                        var _opts$createSocket = _opts.createSocket;
                                        var createSocket = _opts$createSocket === undefined ? defaultCreateSocket : _opts$createSocket;
                                        var protocols = _opts.protocols;

                                        _this2.socket = createSocket(_this2._url, protocols);
                                        var connectionTimeout = null;
                                        if (_this2.connectionTimeoutMsecs) {
                                            connectionTimeout = setTimeout(function () {
                                                WebSockHop.log("warn", "Connection timeout exceeded.");
                                                _this2._raiseErrorEvent(false);
                                            }, _this2.connectionTimeoutMsecs);
                                            WebSockHop.log("info", "Setting connection timeout (" + _this2.connectionTimeoutMsecs + " msecs).");
                                        }
                                        var clearConnectionTimeout = function clearConnectionTimeout() {
                                            if (connectionTimeout != null) {
                                                WebSockHop.log("info", "Clearing connection timeout.");
                                                clearTimeout(connectionTimeout);
                                                connectionTimeout = null;
                                            }
                                        };
                                        _this2.socket.onopen = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                                            return _regenerator2.default.wrap(function _callee3$(_context3) {
                                                while (1) {
                                                    switch (_context3.prev = _context3.next) {
                                                        case 0:
                                                            WebSockHop.log("info", "WebSocket::onopen");
                                                            clearConnectionTimeout();
                                                            _this2.protocol = _this2.socket.protocol;
                                                            _this2._tries = 0;
                                                            _context3.next = 6;
                                                            return _this2._raiseEvent("opened");

                                                        case 6:
                                                            _this2._resetPingTimer();

                                                        case 7:
                                                        case "end":
                                                            return _context3.stop();
                                                    }
                                                }
                                            }, _callee3, _this2);
                                        }));
                                        _this2.socket.onclose = function (_ref6) {
                                            var wasClean = _ref6.wasClean;
                                            var code = _ref6.code;

                                            WebSockHop.log("info", "WebSocket::onclose { wasClean: " + (wasClean ? "true" : "false") + ", code: " + code + " }");
                                            clearConnectionTimeout();
                                            var closing = _this2._closing;

                                            if (wasClean) {
                                                (0, _utils.nextUpdate)((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
                                                    return _regenerator2.default.wrap(function _callee4$(_context4) {
                                                        while (1) {
                                                            switch (_context4.prev = _context4.next) {
                                                                case 0:
                                                                    _context4.next = 2;
                                                                    return _this2._raiseEvent("closed");

                                                                case 2:
                                                                    _this2.socket = null;

                                                                case 3:
                                                                case "end":
                                                                    return _context4.stop();
                                                            }
                                                        }
                                                    }, _callee4, _this2);
                                                })));
                                            } else {
                                                (0, _utils.nextUpdate)(function () {
                                                    _this2._raiseErrorEvent(closing);
                                                });
                                            }
                                            _this2._clearPingTimers();
                                        };
                                        _this2.socket.onmessage = function (_ref8) {
                                            var data = _ref8.data;

                                            (0, _utils.nextUpdate)(function () {
                                                WebSockHop.log("info", "WebSocket::onmessage { data: " + data + " }");
                                                _this2._dispatchMessage(data);
                                            });
                                        };
                                    })();
                                }

                            case 4:
                            case "end":
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function _start() {
                return _ref4.apply(this, arguments);
            }

            return _start;
        }()
    }, {
        key: "_raiseErrorEvent",
        value: function () {
            var _ref9 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6(isClosing) {
                var willRetry, pendingRequestIds, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, requestId;

                return _regenerator2.default.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                willRetry = !isClosing;
                                _context6.next = 3;
                                return this._raiseEvent("error", willRetry);

                            case 3:
                                this.socket = null;

                                if (!(this.formatter != null)) {
                                    _context6.next = 33;
                                    break;
                                }

                                pendingRequestIds = this.formatter.getPendingHandlerIds();

                                if (!Array.isArray(pendingRequestIds)) {
                                    _context6.next = 33;
                                    break;
                                }

                                _iteratorNormalCompletion = true;
                                _didIteratorError = false;
                                _iteratorError = undefined;
                                _context6.prev = 10;
                                _iterator = (0, _getIterator3.default)(pendingRequestIds);

                            case 12:
                                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                                    _context6.next = 19;
                                    break;
                                }

                                requestId = _step.value;
                                _context6.next = 16;
                                return this._dispatchErrorMessage(requestId, { type: _ErrorEnumValue2.default.Disconnect });

                            case 16:
                                _iteratorNormalCompletion = true;
                                _context6.next = 12;
                                break;

                            case 19:
                                _context6.next = 25;
                                break;

                            case 21:
                                _context6.prev = 21;
                                _context6.t0 = _context6["catch"](10);
                                _didIteratorError = true;
                                _iteratorError = _context6.t0;

                            case 25:
                                _context6.prev = 25;
                                _context6.prev = 26;

                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }

                            case 28:
                                _context6.prev = 28;

                                if (!_didIteratorError) {
                                    _context6.next = 31;
                                    break;
                                }

                                throw _iteratorError;

                            case 31:
                                return _context6.finish(28);

                            case 32:
                                return _context6.finish(25);

                            case 33:
                                if (willRetry) {
                                    this._attemptConnect();
                                }

                            case 34:
                            case "end":
                                return _context6.stop();
                        }
                    }
                }, _callee6, this, [[10, 21, 25, 33], [26,, 28, 32]]);
            }));

            function _raiseErrorEvent(_x4) {
                return _ref9.apply(this, arguments);
            }

            return _raiseErrorEvent;
        }()
    }, {
        key: "_clearPingTimers",
        value: function _clearPingTimers() {
            WebSockHop.log("info", "clearing ping timers.");
            if (this._pingTimer) {
                clearTimeout(this._pingTimer);
                this._pingTimer = null;
            }
        }
    }, {
        key: "_resetPingTimer",
        value: function _resetPingTimer() {
            var _this3 = this;

            WebSockHop.log("info", "resetting ping timer.");
            this._clearPingTimers();
            this._pingTimer = setTimeout(function () {
                _this3.sendPingRequest();
            }, this.pingIntervalMsecs);
            WebSockHop.log("info", "attempting ping in " + this.pingIntervalMsecs + " ms");
        }
    }, {
        key: "sendPingRequest",
        value: function sendPingRequest() {
            var _this4 = this;

            if (this.formatter != null) {
                var _formatter = this.formatter;
                var pingRequest = _formatter.pingRequest;
                var pingMessage = _formatter.pingMessage;


                if ((0, _utils.isObject)(pingRequest)) {
                    var ping = (0, _assign2.default)({}, pingRequest);
                    this._lastSentPing = this.request(ping, function (obj) {
                        _this4._lastReceivedPongId = obj.id;
                    }, function (error) {
                        if (error.type == _ErrorEnumValue2.default.Timeout) {
                            WebSockHop.log("info", "no ping response, handling as disconnected");
                        }
                    }, this.pingResponseTimeoutMsecs, true);
                    WebSockHop.log("info", "> PING [" + ping.id + "], requiring response in " + this.pingResponseTimeoutMsecs + " ms");
                } else if (pingMessage != null) {
                    this._lastSentPing = this._sendPingMessage(pingMessage, this.pingResponseTimeoutMsecs);
                    WebSockHop.log("info", "> PING, requiring response in " + this.pingResponseTimeoutMsecs + " ms");
                } else {
                    WebSockHop.log("info", "No ping set up for message formatter, not performing ping.");
                }
            } else {
                WebSockHop.log("info", "Time for ping, but no formatter selected, not performing ping.");
            }
        }
    }, {
        key: "send",
        value: function send(obj) {
            if (this.socket) {
                var message = this.formatter.toMessage(obj);
                this.socket.send(message);
            }
        }
    }, {
        key: "close",
        value: function close() {
            var _this5 = this;

            if (this.socket) {
                this._closing = true;
                this.socket.close();
            } else {
                this._abortConnect();
                this._clearPingTimers();
                (0, _utils.nextUpdate)(function () {
                    _this5._raiseErrorEvent(true);
                });
            }
        }
    }, {
        key: "abort",
        value: function abort() {
            if (this.socket) {
                WebSockHop.log("warn", "abort() called on live socket, performing forceful shutdown.  Did you mean to call close() ?");
                this._clearPingTimers();
                this._lastSentPing = null;
                this._lastReceivedPongId = 0;
                this.socket.onclose = null;
                this.socket.onmessage = null;
                this.socket.onerror = null;
                this.socket.close();
                this.socket = null;
                this.protocol = null;
            }
            this._abortConnect();
        }
    }, {
        key: "on",
        value: function on(type, handler) {
            this._events.on(type, handler);
        }
    }, {
        key: "off",
        value: function off(type) {
            var _events2;

            for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                args[_key2 - 1] = arguments[_key2];
            }

            (_events2 = this._events).off.apply(_events2, [type].concat(args));
        }
    }, {
        key: "request",
        value: function request(obj, _callback, _errorCallback, timeoutMsecs, disconnectOnTimeout) {
            var request = {
                obj: obj,
                requestTimeoutTimer: null,
                requestTimeoutMsecs: typeof timeoutMsecs !== 'undefined' ? timeoutMsecs : this.defaultRequestTimeoutMsecs,
                requestDisconnectOnTimeout: typeof disconnectOnTimeout !== 'undefined' ? disconnectOnTimeout : this.defaultDisconnectOnRequestTimeout,
                clearTimeout: function (_clearTimeout) {
                    function clearTimeout() {
                        return _clearTimeout.apply(this, arguments);
                    }

                    clearTimeout.toString = function () {
                        return _clearTimeout.toString();
                    };

                    return clearTimeout;
                }(function () {
                    if (this.requestTimeoutTimer != null) {
                        clearTimeout(this.requestTimeoutTimer);
                        this.requestTimeoutTimer = null;
                    }
                })
            };

            this.formatter.trackRequest(obj, {
                callback: function callback(o) {
                    request.clearTimeout();
                    if (_callback != null) {
                        _callback(o);
                    }
                },
                errorCallback: function errorCallback(err) {
                    if (_errorCallback != null) {
                        _errorCallback(err);
                    }
                }
            });
            this.send(obj);
            if (request.requestTimeoutMsecs > 0) {

                this._startRequestTimeout(request);
            }

            return request;
        }
    }, {
        key: "_startRequestTimeout",
        value: function _startRequestTimeout(request) {
            var _this6 = this;

            var id = request.obj.id;

            request.clearTimeout();
            request.requestTimeoutTimer = setTimeout((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7() {
                return _regenerator2.default.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                WebSockHop.log("info", "timeout exceeded [" + id + "]");
                                _context7.next = 3;
                                return _this6._dispatchErrorMessage(id, { type: _ErrorEnumValue2.default.Timeout });

                            case 3:
                                if (!request.requestDisconnectOnTimeout) {
                                    _context7.next = 6;
                                    break;
                                }

                                _context7.next = 6;
                                return _this6._raiseErrorEvent(false);

                            case 6:
                            case "end":
                                return _context7.stop();
                        }
                    }
                }, _callee7, _this6);
            })), request.requestTimeoutMsecs);
        }
    }, {
        key: "_sendPingMessage",
        value: function _sendPingMessage(message, timeoutMsecs) {
            var pingMessage = {
                obj: message,
                messageTimeoutTimer: null,
                messageTimeoutMsecs: typeof timeoutMsecs !== 'undefined' ? timeoutMsecs : this.defaultRequestTimeoutMsecs,
                clearTimeout: function (_clearTimeout2) {
                    function clearTimeout() {
                        return _clearTimeout2.apply(this, arguments);
                    }

                    clearTimeout.toString = function () {
                        return _clearTimeout2.toString();
                    };

                    return clearTimeout;
                }(function () {
                    if (this.messageTimeoutTimer != null) {
                        clearTimeout(this.messageTimeoutTimer);
                        this.messageTimeoutTimer = null;
                    }
                })
            };
            this.send(message);
            if (pingMessage.messageTimeoutMsecs > 0) {
                this._startPingMessageTimeout(pingMessage);
            }
            return pingMessage;
        }
    }, {
        key: "_startPingMessageTimeout",
        value: function _startPingMessageTimeout(pingMessage) {
            var _this7 = this;

            pingMessage.clearTimeout();
            pingMessage.messageTimeoutTimer = setTimeout(function () {
                WebSockHop.log("info", "timeout exceeded");
                _this7._raiseErrorEvent(false);
            }, pingMessage.messageTimeoutMsecs);
        }
    }, {
        key: "_dispatchMessage",
        value: function () {
            var _ref11 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8(message) {
                var isHandled, obj, isPong, pongId, _formatter2, pingRequest, pingMessage, handler, isPing;

                return _regenerator2.default.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                isHandled = false;
                                obj = this.formatter.fromMessage(message);

                                if (!(this.formatter != null)) {
                                    _context8.next = 34;
                                    break;
                                }

                                isPong = false;
                                pongId = 0;
                                _formatter2 = this.formatter;
                                pingRequest = _formatter2.pingRequest;
                                pingMessage = _formatter2.pingMessage;

                                if (!(0, _utils.isObject)(pingRequest)) {
                                    _context8.next = 18;
                                    break;
                                }

                                // Check for request-based ping response

                                // See if this object is a response to a request().
                                handler = (0, _utils.isObject)(obj) ? this.formatter.getHandlerForResponse(obj) : null;

                                if (!(handler != null)) {
                                    _context8.next = 15;
                                    break;
                                }

                                _context8.next = 13;
                                return _promise2.default.resolve(handler.callback(obj));

                            case 13:
                                if (this._lastSentPing != null && this._lastSentPing.obj != null && this._lastSentPing.obj.id == this._lastReceivedPongId) {
                                    this._lastSentPing = null;
                                    this._lastReceivedPongId = 0;
                                    isPong = true;
                                    pongId = obj.id;
                                }
                                isHandled = true;

                            case 15:

                                // If this is NOT a pong then just extend the response timer, if any
                                if (!isPong && this._lastSentPing != null) {
                                    WebSockHop.log("info", "Non-pong received during pong response period, extending delay...");
                                    this._startRequestTimeout(this._lastSentPing);
                                }

                                _context8.next = 28;
                                break;

                            case 18:
                                if (!(pingMessage != null)) {
                                    _context8.next = 28;
                                    break;
                                }

                                if (!(0, _utils.isFunction)(this.formatter.handlePong)) {
                                    _context8.next = 26;
                                    break;
                                }

                                _context8.next = 22;
                                return _promise2.default.resolve(this.formatter.handlePong(obj));

                            case 22:
                                isPong = _context8.sent;

                                if (isPong) {
                                    isHandled = true;
                                }
                                _context8.next = 27;
                                break;

                            case 26:
                                // If handlePong is null, then any message counts as a pong,
                                // but we don't eat the message.
                                isPong = true;

                            case 27:

                                if (this._lastSentPing != null) {
                                    if (isPong) {
                                        // If this is a pong then clear the pong timer.
                                        this._lastSentPing.clearTimeout();
                                        this._lastSentPing = null;
                                    } else {
                                        // If this is NOT a pong then just extend the response timer, if any
                                        WebSockHop.log("info", "Non-pong received during pong response period, extending delay...");
                                        this._startPingMessageTimeout(this._lastSentPing);
                                    }
                                }

                            case 28:

                                if (isPong) {
                                    if (pongId > 0) {
                                        WebSockHop.log("info", "< PONG [" + pongId + "]");
                                    } else {
                                        WebSockHop.log("info", "< PONG");
                                    }
                                    this._resetPingTimer();
                                }

                                if (!(!isHandled && (0, _utils.isFunction)(this.formatter.handlePing))) {
                                    _context8.next = 34;
                                    break;
                                }

                                _context8.next = 32;
                                return _promise2.default.resolve(this.formatter.handlePing(obj));

                            case 32:
                                isPing = _context8.sent;

                                if (isPing) {
                                    WebSockHop.log("info", "Received PING message, handled.");
                                    isHandled = true;
                                }

                            case 34:
                                if (isHandled) {
                                    _context8.next = 37;
                                    break;
                                }

                                _context8.next = 37;
                                return this._raiseEvent("message", obj);

                            case 37:
                            case "end":
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function _dispatchMessage(_x5) {
                return _ref11.apply(this, arguments);
            }

            return _dispatchMessage;
        }()
    }, {
        key: "_dispatchErrorMessage",
        value: function () {
            var _ref12 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9(id, error) {
                var handler;
                return _regenerator2.default.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                if (!(this.formatter != null)) {
                                    _context9.next = 5;
                                    break;
                                }

                                handler = this.formatter.getHandlerForResponse({ id: id });

                                if (!(handler != null)) {
                                    _context9.next = 5;
                                    break;
                                }

                                _context9.next = 5;
                                return _promise2.default.resolve(handler.errorCallback(error));

                            case 5:
                            case "end":
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function _dispatchErrorMessage(_x6, _x7) {
                return _ref12.apply(this, arguments);
            }

            return _dispatchErrorMessage;
        }()
    }], [{
        key: "isAvailable",
        value: function isAvailable() {
            if ((0, _browserDetection.isWebSocketUnavailable)()) {
                return false;
            }

            if (this.disable.oldSafari && (0, _browserDetection.isInvalidSafari)()) {
                return false;
            }

            if (this.disable.mobile && (0, _browserDetection.isMobile)()) {
                return false;
            }

            return true;
        }
    }]);
    return WebSockHop;
}();

WebSockHop.logger = null;
if (process.env.NODE_ENV === 'development') {
    WebSockHop.logger = function (type, message) {
        console.log("WebSockHop: " + type + " - " + message);
    };
}

WebSockHop.log = function (type, message) {
    if (WebSockHop.logger != null) {
        WebSockHop.logger(type, message);
    }
};

WebSockHop.disable = { oldSafari: true, mobile: true };
WebSockHop.ErrorEnumValue = _ErrorEnumValue2.default;
WebSockHop.StringFormatter = _formatters.StringFormatter;
WebSockHop.JsonFormatter = _formatters.JsonFormatter;
WebSockHop.MessageFormatterBase = _formatters.MessageFormatterBase;

exports.default = WebSockHop;
}).call(this,require('_process'))
},{"./ErrorEnumValue":151,"./Events":152,"./browserDetection":154,"./formatters":155,"./utils":157,"_process":148,"babel-runtime/core-js/get-iterator":2,"babel-runtime/core-js/object/assign":5,"babel-runtime/core-js/promise":12,"babel-runtime/helpers/asyncToGenerator":16,"babel-runtime/helpers/classCallCheck":17,"babel-runtime/helpers/createClass":18,"babel-runtime/regenerator":24}],154:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
// UserAgent detection, borrowed from jQuery migrate
// https://github.com/jquery/jquery-migrate
function uaMatch(ua) {
    ua = ua.toLowerCase();

    var match = /(chrome)[ \/]([\w.]+)/.exec(ua) || /(webkit)[ \/]([\w.]+)/.exec(ua) || /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(ua) || /(msie) ([\w.]+)/.exec(ua) || ua.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua) || [];

    return {
        browser: match[1] || "",
        version: match[2] || "0"
    };
}

function detectBrowser() {
    var matched = uaMatch(window.navigator.userAgent);
    var browser = {};

    if (matched.browser) {
        browser[matched.browser] = true;
        browser.version = matched.version;
    }

    // Chrome is Webkit, but Webkit is also Safari.
    if (browser.chrome) {
        browser.webkit = true;
    } else if (browser.webkit) {
        browser.safari = true;
    }

    return browser;
}

var browser = detectBrowser();

// WebSockets unavailable under certain conditions

function isWebSocketUnavailable() {
    return !("WebSocket" in window);
}

function isInvalidSafari() {
    return browser.safari && !browser.chrome && parseFloat(browser.version) < 534.54;
}

function detectMobile(a) {
    return (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))
    );
}

function isMobile() {
    return detectMobile(navigator.userAgent || navigator.vendor || window.opera);
}

exports.isWebSocketUnavailable = isWebSocketUnavailable;
exports.isInvalidSafari = isInvalidSafari;
exports.isMobile = isMobile;
},{}],155:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.JsonFormatter = exports.StringFormatter = exports.MessageFormatterBase = undefined;

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _map = require("babel-runtime/core-js/map");

var _map2 = _interopRequireDefault(_map);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MessageFormatterBase = exports.MessageFormatterBase = function () {
    function MessageFormatterBase() {
        (0, _classCallCheck3.default)(this, MessageFormatterBase);
    }

    (0, _createClass3.default)(MessageFormatterBase, [{
        key: "toMessage",
        value: function toMessage(obj) {
            throw "Not Implemented";
        }
    }, {
        key: "fromMessage",
        value: function fromMessage(message) {
            throw "Not Implemented";
        }
    }, {
        key: "trackRequest",
        value: function trackRequest(requestObject, handler) {
            throw "Not Implemented";
        }
    }, {
        key: "getHandlerForResponse",
        value: function getHandlerForResponse(responseObject) {
            return null;
        }
    }, {
        key: "getPendingHandlerIds",
        value: function getPendingHandlerIds() {
            return null;
        }
    }]);
    return MessageFormatterBase;
}();

(0, _assign2.default)(MessageFormatterBase.prototype, {
    pingMessage: null,
    pingRequest: null,
    handlePing: null,
    handlePong: null
});

var StringFormatter = exports.StringFormatter = function (_MessageFormatterBase) {
    (0, _inherits3.default)(StringFormatter, _MessageFormatterBase);

    function StringFormatter() {
        (0, _classCallCheck3.default)(this, StringFormatter);
        return (0, _possibleConstructorReturn3.default)(this, (StringFormatter.__proto__ || (0, _getPrototypeOf2.default)(StringFormatter)).apply(this, arguments));
    }

    (0, _createClass3.default)(StringFormatter, [{
        key: "toMessage",
        value: function toMessage(obj) {
            return obj.toString();
        }
    }, {
        key: "fromMessage",
        value: function fromMessage(message) {
            return message;
        }
    }]);
    return StringFormatter;
}(MessageFormatterBase);

var JsonFormatter = exports.JsonFormatter = function (_MessageFormatterBase2) {
    (0, _inherits3.default)(JsonFormatter, _MessageFormatterBase2);

    function JsonFormatter() {
        (0, _classCallCheck3.default)(this, JsonFormatter);

        var _this2 = (0, _possibleConstructorReturn3.default)(this, (JsonFormatter.__proto__ || (0, _getPrototypeOf2.default)(JsonFormatter)).call(this));

        _this2._requestMap = new _map2.default();
        _this2._nextId = 0;
        return _this2;
    }

    (0, _createClass3.default)(JsonFormatter, [{
        key: "toMessage",
        value: function toMessage(obj) {
            return (0, _stringify2.default)(obj);
        }
    }, {
        key: "fromMessage",
        value: function fromMessage(message) {
            return JSON.parse(message);
        }
    }, {
        key: "trackRequest",
        value: function trackRequest(requestObject, handler) {
            requestObject.id = ++this._nextId;
            this._requestMap.set(requestObject.id, handler);
            return requestObject;
        }
    }, {
        key: "getHandlerForResponse",
        value: function getHandlerForResponse(_ref) {
            var id = _ref.id;

            if (id == null) {
                return null;
            }
            var handler = this._requestMap.get(id);
            if (handler == null) {
                return null;
            }
            this._requestMap.delete(id);
            return handler;
        }
    }, {
        key: "getPendingHandlerIds",
        value: function getPendingHandlerIds() {
            return this._requestMap.keys();
        }
    }]);
    return JsonFormatter;
}(MessageFormatterBase);
},{"babel-runtime/core-js/json/stringify":3,"babel-runtime/core-js/map":4,"babel-runtime/core-js/object/assign":5,"babel-runtime/core-js/object/get-prototype-of":9,"babel-runtime/helpers/classCallCheck":17,"babel-runtime/helpers/createClass":18,"babel-runtime/helpers/inherits":20,"babel-runtime/helpers/possibleConstructorReturn":21}],156:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _WebSockHop = require("./WebSockHop");

Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_WebSockHop).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
},{"./WebSockHop":153}],157:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isFunction = isFunction;
exports.nextUpdate = nextUpdate;
exports.isObject = isObject;
exports.removeFromArray = removeFromArray;
function isFunction(obj) {
    return Object.prototype.toString.call(obj) == '[object Function]';
}

function nextUpdate(predicate) {
    return setTimeout(predicate, 0);
}

function isObject(obj) {
    return obj != null && obj === Object(obj);
}

function removeFromArray(array, item) {
    var again = true;
    while (again) {
        var index = array.indexOf(item);
        if (index != -1) {
            array.splice(index, 1);
        } else {
            again = false;
        }
    }
}
},{}],158:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _map = require('babel-runtime/core-js/map');

var _map2 = _interopRequireDefault(_map);

var _weakMap = require('babel-runtime/core-js/weak-map');

var _weakMap2 = _interopRequireDefault(_weakMap);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _utils = require('../../utils');

var _utils2 = require('../../utils.parseLinkHeader');

var _Logger = require('../../Logger');

var Logger = _interopRequireWildcard(_Logger);

var _EngineUnit2 = require('../../Framework/EngineUnit');

var _EngineUnit3 = _interopRequireDefault(_EngineUnit2);

var _ChangesResourcePart = require('./ChangesResourcePart');

var _ChangesResourcePart2 = _interopRequireDefault(_ChangesResourcePart);

var _ChangesWaitConnection = require('./ChangesWaitConnection');

var _ChangesWaitConnection2 = _interopRequireDefault(_ChangesWaitConnection);

var _CollectionEntry = require('../../Framework/CollectionEntry');

var _CollectionEntry2 = _interopRequireDefault(_CollectionEntry);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChangesEngineUnit = function (_EngineUnit) {
    (0, _inherits3.default)(ChangesEngineUnit, _EngineUnit);

    function ChangesEngineUnit() {
        (0, _classCallCheck3.default)(this, ChangesEngineUnit);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ChangesEngineUnit.__proto__ || (0, _getPrototypeOf2.default)(ChangesEngineUnit)).call(this));

        _this._changesWaitConnections = [];

        _this._liveResourceItemIds = new _weakMap2.default();
        return _this;
    }

    (0, _createClass3.default)(ChangesEngineUnit, [{
        key: 'updateEndpointsToResourceParts',
        value: function updateEndpointsToResourceParts(parts) {
            var _this2 = this;

            var changesWaitItems = new _map2.default();
            parts.forEach(function (part) {
                if (part.linkUris['CHANGES_WAIT']) {
                    changesWaitItems.set(part.linkUris['CHANGES_WAIT'], part);
                }
            });

            var changesWaitEndpoints = new _map2.default();
            changesWaitItems.forEach(function (endpoint, endpointUri) {
                changesWaitEndpoints.set(endpointUri, { endpointUri: endpointUri, item: endpoint });
            });

            this.updateConnectionsToMatchEndpoints('Changes Wait', this._changesWaitConnections, changesWaitEndpoints, function (endpoint) {
                return new _ChangesWaitConnection2.default(_this2, endpoint);
            });
        }
    }, {
        key: 'createResourcePart',
        value: function createResourcePart(resourceHandler) {
            var _this3 = this;

            var resource = new _ChangesResourcePart2.default(resourceHandler);

            var request = this.createLongPoll();
            request.on('finished', function (code, result, headers) {

                if (code >= 200 && code < 300) {
                    _this3.updateResourcePart(resource, headers, result);
                    if (!resource.linkUris['CHANGES_WAIT']) {
                        Logger.info('no changes-wait link');
                    }
                    _this3.updateEngine();
                    request = null;
                } else if (code >= 400) {
                    request.retry();
                }
            });
            request.start('HEAD', resourceHandler.uri);

            return resource;
        }
    }, {
        key: 'updateResourcePart',
        value: function updateResourcePart(resourcePart, headers, result) {

            var parsedHeaders = ChangesEngineUnit.parseHeaders(headers, resourcePart.resourceHandler.uri);

            this.updateConnection(resourcePart, this._changesWaitConnections, 'CHANGES_WAIT', parsedHeaders.changesWaitUri);

            (0, _get3.default)(ChangesEngineUnit.prototype.__proto__ || (0, _getPrototypeOf2.default)(ChangesEngineUnit.prototype), 'updateResourcePart', this).call(this, resourcePart, headers, result);
        }
    }, {
        key: 'triggerEvents',
        value: function triggerEvents(part, headers, result) {
            var _this4 = this;

            // TODO: This timing of emitting 'ready' is incorrect.
            // It should be done separately, because it means the listening connection
            // is established.
            if (!part.started) {
                part.started = true;
                part.resourceHandler.triggerOnceOnlyEvent('ready', part.resourceHandler);
            }

            if (result) {
                // parsed are CollectionEntry items.
                part.resourceHandler.forEachLiveResource(function (liveResource) {
                    var itemIds = (0, _utils.getOrCreateEntry)(_this4._liveResourceItemIds, liveResource, function () {
                        return [];
                    });

                    // TODO: ContentType
                    var parsed = liveResource.parse(_this4.interestType, headers, result);
                    parsed.forEach(function (parsedItem) {
                        if (parsedItem.deleted) {
                            liveResource.trigger('child-deleted', liveResource, parsedItem.item);
                            var deleteIndex = itemIds.indexOf(parsedItem.id);
                            if (deleteIndex >= 0) {
                                itemIds.splice(deleteIndex, 1);
                            }
                        } else {
                            if (itemIds.indexOf(parsedItem.id) >= 0) {
                                liveResource.trigger('child-updated', liveResource, parsedItem.item);
                            } else {
                                if (parsedItem.id) {
                                    itemIds.push(parsedItem.id);
                                }
                                liveResource.trigger('child-added', liveResource, parsedItem.item);
                            }
                        }
                    });
                });
            }
        }
    }, {
        key: 'defaultParser',
        value: function defaultParser(headers, data) {
            var parsed = JSON.parse(data);
            var out = [];
            if (Array.isArray(parsed)) {
                var items = parsed;
                for (var i = 0; i < items.length; ++i) {
                    var id = items[i].id;
                    var deleted = items[i].deleted;
                    delete items[i].deleted; // app should not see this
                    out.push(new _CollectionEntry2.default(id, deleted, items[i]));
                }
            } else {
                var item = parsed;
                var _id = item.id;
                var _deleted = item.deleted;
                delete item.deleted; // app should not see this
                out.push(new _CollectionEntry2.default(_id, _deleted, item));
            }
            return out;
        }
    }, {
        key: 'interestType',
        get: function get() {
            return 'changes';
        }
    }, {
        key: 'events',
        get: function get() {
            return ['child-added', 'child-removed'];
        }
    }], [{
        key: 'parseHeaders',
        value: function parseHeaders(headers, baseUri) {
            var changesWaitUri = null;

            (0, _keys2.default)(headers).forEach(function (key) {
                var header = headers[key];
                var k = key.toLowerCase();
                if (k == 'link') {
                    var links = (0, _utils2.parseLinkHeader)(header);
                    if (links && links['changes-wait']) {
                        changesWaitUri = (0, _utils.toAbsoluteUri)(baseUri, links['changes-wait']['href']);
                    }
                }
            });

            var result = {};

            if (changesWaitUri) {
                Logger.info('changes-wait: [' + changesWaitUri + ']');
                result.changesWaitUri = changesWaitUri;
            }

            return result;
        }
    }]);
    return ChangesEngineUnit;
}(_EngineUnit3.default);

exports.default = ChangesEngineUnit;

},{"../../Framework/CollectionEntry":166,"../../Framework/EngineUnit":169,"../../Logger":175,"../../utils":178,"../../utils.parseLinkHeader":180,"./ChangesResourcePart":159,"./ChangesWaitConnection":160,"babel-runtime/core-js/map":4,"babel-runtime/core-js/object/get-prototype-of":9,"babel-runtime/core-js/object/keys":10,"babel-runtime/core-js/weak-map":15,"babel-runtime/helpers/classCallCheck":17,"babel-runtime/helpers/createClass":18,"babel-runtime/helpers/get":19,"babel-runtime/helpers/inherits":20,"babel-runtime/helpers/possibleConstructorReturn":21}],159:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _ResourcePart2 = require('../../Framework/ResourcePart');

var _ResourcePart3 = _interopRequireDefault(_ResourcePart2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChangesResourcePart = function (_ResourcePart) {
    (0, _inherits3.default)(ChangesResourcePart, _ResourcePart);

    function ChangesResourcePart(resourceHandler) {
        (0, _classCallCheck3.default)(this, ChangesResourcePart);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ChangesResourcePart.__proto__ || (0, _getPrototypeOf2.default)(ChangesResourcePart)).call(this, resourceHandler));

        _this.started = false;
        _this.linkUris['CHANGES_WAIT'] = null;
        return _this;
    }

    return ChangesResourcePart;
}(_ResourcePart3.default);

exports.default = ChangesResourcePart;

},{"../../Framework/ResourcePart":173,"babel-runtime/core-js/object/get-prototype-of":9,"babel-runtime/helpers/classCallCheck":17,"babel-runtime/helpers/inherits":20,"babel-runtime/helpers/possibleConstructorReturn":21}],160:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _Logger = require("../../Logger");

var Logger = _interopRequireWildcard(_Logger);

var _Connection2 = require("../../Framework/Connection");

var _Connection3 = _interopRequireDefault(_Connection2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChangesWaitConnection = function (_Connection) {
    (0, _inherits3.default)(ChangesWaitConnection, _Connection);

    function ChangesWaitConnection(engineUnit, endpoint) {
        (0, _classCallCheck3.default)(this, ChangesWaitConnection);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ChangesWaitConnection.__proto__ || (0, _getPrototypeOf2.default)(ChangesWaitConnection)).call(this, engineUnit));

        _this.uri = endpoint.endpointUri;
        _this.request = engineUnit.createLongPoll();
        _this.res = endpoint.item;
        _this.isActive = false;

        _this.request.on("finished", function (code, result, headers) {
            _this.isActive = false;

            if (code >= 200 && code < 300) {
                engineUnit.updateResourcePart(_this.res, headers, result);
            }

            _this._engineUnit.updateEngine();
        });
        return _this;
    }

    (0, _createClass3.default)(ChangesWaitConnection, [{
        key: "hasChanged",
        value: function hasChanged(endpoint) {
            return this.res.resourceHandler.uri != endpoint.item.resourceHandler.uri;
        }
    }, {
        key: "abort",
        value: function abort() {
            this.request.abort();
        }
    }, {
        key: "refresh",
        value: function refresh(endpoint) {
            if (!this.isActive) {
                var requestUri = this.uri;
                Logger.info("Changes Wait Request URI: " + requestUri);
                this._engineUnit.setLongPollOptions(this.request);
                this.request.start('GET', requestUri, {
                    'Wait': 55
                });
                this.isActive = true;
            }
        }
    }]);
    return ChangesWaitConnection;
}(_Connection3.default);

exports.default = ChangesWaitConnection;

},{"../../Framework/Connection":167,"../../Logger":175,"babel-runtime/core-js/object/get-prototype-of":9,"babel-runtime/helpers/classCallCheck":17,"babel-runtime/helpers/createClass":18,"babel-runtime/helpers/inherits":20,"babel-runtime/helpers/possibleConstructorReturn":21}],161:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _utils = require('../../utils');

var _Logger = require('../../Logger');

var Logger = _interopRequireWildcard(_Logger);

var _Connection2 = require('../../Framework/Connection');

var _Connection3 = _interopRequireDefault(_Connection2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MultiplexWaitConnection = function (_Connection) {
    (0, _inherits3.default)(MultiplexWaitConnection, _Connection);

    function MultiplexWaitConnection(engineUnit, endpoint) {
        (0, _classCallCheck3.default)(this, MultiplexWaitConnection);

        var _this = (0, _possibleConstructorReturn3.default)(this, (MultiplexWaitConnection.__proto__ || (0, _getPrototypeOf2.default)(MultiplexWaitConnection)).call(this, engineUnit));

        _this.uri = endpoint.endpointUri;
        _this.request = engineUnit.createLongPoll();
        _this.resItems = endpoint.items.slice();
        _this.isActive = false;

        _this.request.on("finished", function (code, result, headers) {
            _this.isActive = false;

            if (code >= 200 && code < 300) {

                (0, _keys2.default)(result).forEach(function (uri) {
                    var item = result[uri];
                    Logger.info('got data for uri: ' + uri);
                    var absoluteUri = (0, _utils.toAbsoluteUri)(_this.uri, uri);
                    engineUnit.updateResources(absoluteUri, item.headers, item.body);
                });
            }

            _this._engineUnit.updateEngine();
        });
        return _this;
    }

    (0, _createClass3.default)(MultiplexWaitConnection, [{
        key: 'hasChanged',
        value: function hasChanged(endpoint) {
            var _this2 = this;

            var removedOrChanged = false;
            if (endpoint.items.length != this.resItems.length) {
                removedOrChanged = true;
            } else {
                (function () {

                    // At this point we know the two arrays are the same length.
                    // Sort them and then compare their contents one by one.

                    var preferredEndpointItemUris = [];
                    endpoint.items.forEach(function (item) {
                        preferredEndpointItemUris.push(item.resourceHandler.uri);
                    });
                    preferredEndpointItemUris.sort();

                    var pollResourceItemUris = [];
                    _this2.resItems.forEach(function (resItem) {
                        pollResourceItemUris.push(resItem.resourceHandler.uri);
                    });
                    pollResourceItemUris.sort();

                    for (var i = 0; i < preferredEndpointItemUris.length; i++) {
                        if (preferredEndpointItemUris[i] != pollResourceItemUris[i]) {
                            removedOrChanged = true;
                            break;
                        }
                    }
                })();
            }
            return removedOrChanged;
        }
    }, {
        key: 'abort',
        value: function abort() {
            this.request.abort();
        }
    }, {
        key: 'refresh',
        value: function refresh(endpoint) {
            var _this3 = this;

            if (!this.isActive) {
                (function () {
                    var urlSegments = [];
                    _this3.resItems.forEach(function (res) {
                        var uri = res.resourceHandler.uri;
                        urlSegments.push('u=' + encodeURIComponent(uri) + '&inm=' + encodeURIComponent(res.etag));
                    });

                    var requestUri = _this3.uri + '?' + urlSegments.join('&');
                    Logger.info('Multiplex Wait Request URI: ' + requestUri);
                    _this3._engineUnit.setLongPollOptions(_this3.request);
                    _this3.request.start('GET', requestUri, {
                        'Wait': 55
                    });
                    _this3.isActive = true;
                })();
            }
        }
    }]);
    return MultiplexWaitConnection;
}(_Connection3.default);

exports.default = MultiplexWaitConnection;

},{"../../Framework/Connection":167,"../../Logger":175,"../../utils":178,"babel-runtime/core-js/object/get-prototype-of":9,"babel-runtime/core-js/object/keys":10,"babel-runtime/helpers/classCallCheck":17,"babel-runtime/helpers/createClass":18,"babel-runtime/helpers/inherits":20,"babel-runtime/helpers/possibleConstructorReturn":21}],162:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _utils = require('../../utils');

var _utils2 = require('../../utils.mapWebSocketUrls');

var _Logger = require('../../Logger');

var Logger = _interopRequireWildcard(_Logger);

var _websockhop = require('websockhop');

var _websockhop2 = _interopRequireDefault(_websockhop);

var _Connection2 = require('../../Framework/Connection');

var _Connection3 = _interopRequireDefault(_Connection2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MultiplexWebSocketConnection = function (_Connection) {
    (0, _inherits3.default)(MultiplexWebSocketConnection, _Connection);

    function MultiplexWebSocketConnection(engineUnit, endpoint) {
        (0, _classCallCheck3.default)(this, MultiplexWebSocketConnection);

        var _this = (0, _possibleConstructorReturn3.default)(this, (MultiplexWebSocketConnection.__proto__ || (0, _getPrototypeOf2.default)(MultiplexWebSocketConnection)).call(this, engineUnit));

        var endpointUri = endpoint.endpointUri;

        _this.uri = endpointUri;
        _this.socket = new _websockhop2.default(endpointUri);
        _this.subscribedItems = {};
        _this.isConnected = false;
        _this.isRetrying = false;

        _this.socket.formatter = new _websockhop2.default.JsonFormatter();

        _this.socket.on("opened", function () {
            _this.socket.on("message", function (data) {

                var uri = data.uri;
                var absoluteUri = (0, _utils.toAbsoluteUri)(endpointUri, uri);
                var httpUri = (0, _utils2.mapWebSocketUrlToHttpUrl)(absoluteUri);

                engineUnit.updateResources(httpUri, data.headers, data.body);
            });
            _this.subscribedItems = {};
            _this.isConnected = true;
            _this.isRetrying = false;

            _this._engineUnit.updateEngine();
        });

        _this.socket.on("closed", function () {
            _this.isConnected = false;
            _this.isRetrying = false;
        });

        _this.socket.on("error", function () {
            _this.isConnected = false;
            _this.isRetrying = true;
        });
        return _this;
    }

    (0, _createClass3.default)(MultiplexWebSocketConnection, [{
        key: 'subscribe',
        value: function subscribe(uri) {
            var _this2 = this;

            var type = 'subscribe',
                mode = 'value';
            this.socket.request({ type: type, mode: mode, uri: uri }, function (result) {
                if (result.type == 'subscribed') {
                    _this2.subscribedItems[uri] = uri;
                }
            });
        }
    }, {
        key: 'unsubscribe',
        value: function unsubscribe(uri) {
            var _this3 = this;

            var type = 'unsubscribe',
                mode = 'value';
            this.socket.request({ type: type, mode: mode, uri: uri }, function (result) {
                if (result.type == 'unsubscribed') {
                    delete _this3.subscribedItems[uri];
                }
            });
        }
    }, {
        key: 'mapToHttpUri',
        value: function mapToHttpUri(uri) {
            var absoluteUri = (0, _utils.toAbsoluteUri)(this.uri, uri);
            return (0, _utils2.mapWebSocketUrlToHttpUrl)(absoluteUri);
        }
    }, {
        key: 'checkSubscriptions',
        value: function checkSubscriptions(items) {
            var _this4 = this;

            var endpointUri = this.uri;
            Logger.info('Multiplex WebSocket Request URI: ' + endpointUri);

            var subscribedItems = (0, _assign2.default)({}, this.subscribedItems);

            items.forEach(function (item) {
                var httpUri = _this4.mapToHttpUri(item.resourceHandler.uri);
                if (httpUri in subscribedItems) {
                    delete subscribedItems[httpUri];
                } else {
                    _this4.subscribe(httpUri);
                }
            });

            (0, _keys2.default)(subscribedItems).forEach(function (uri) {
                return _this4.unsubscribe(uri);
            });
        }
    }, {
        key: 'close',
        value: function close() {
            if (this.isConnected) {
                this.socket.close();
            } else {
                this.socket.abort();
            }
        }
    }, {
        key: 'hasChanged',
        value: function hasChanged(endpoint) {
            return endpoint.items.length == 0;
        }
    }, {
        key: 'abort',
        value: function abort() {
            this.socket.abort();
        }
    }, {
        key: 'refresh',
        value: function refresh(endpoint) {
            if (this.isConnected) {
                this.checkSubscriptions(endpoint.items);
            }
        }
    }], [{
        key: 'isWebSockHopAvailable',
        get: function get() {
            return _websockhop2.default.isAvailable();
        }
    }]);
    return MultiplexWebSocketConnection;
}(_Connection3.default);

exports.default = MultiplexWebSocketConnection;

},{"../../Framework/Connection":167,"../../Logger":175,"../../utils":178,"../../utils.mapWebSocketUrls":179,"babel-runtime/core-js/object/assign":5,"babel-runtime/core-js/object/get-prototype-of":9,"babel-runtime/core-js/object/keys":10,"babel-runtime/helpers/classCallCheck":17,"babel-runtime/helpers/createClass":18,"babel-runtime/helpers/inherits":20,"babel-runtime/helpers/possibleConstructorReturn":21,"websockhop":156}],163:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _map = require('babel-runtime/core-js/map');

var _map2 = _interopRequireDefault(_map);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _utils = require('../../utils');

var _utils2 = require('../../utils.mapWebSocketUrls');

var _utils3 = require('../../utils.parseLinkHeader');

var _Logger = require('../../Logger');

var Logger = _interopRequireWildcard(_Logger);

var _EngineUnit2 = require('../../Framework/EngineUnit');

var _EngineUnit3 = _interopRequireDefault(_EngineUnit2);

var _ValueResourcePart = require('./ValueResourcePart');

var _ValueResourcePart2 = _interopRequireDefault(_ValueResourcePart);

var _ValueWaitConnection = require('./ValueWaitConnection');

var _ValueWaitConnection2 = _interopRequireDefault(_ValueWaitConnection);

var _MultiplexWebSocketConnection = require('./MultiplexWebSocketConnection');

var _MultiplexWebSocketConnection2 = _interopRequireDefault(_MultiplexWebSocketConnection);

var _MultiplexWaitConnection = require('./MultiplexWaitConnection');

var _MultiplexWaitConnection2 = _interopRequireDefault(_MultiplexWaitConnection);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValueEngineUnit = function (_EngineUnit) {
    (0, _inherits3.default)(ValueEngineUnit, _EngineUnit);

    function ValueEngineUnit() {
        (0, _classCallCheck3.default)(this, ValueEngineUnit);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ValueEngineUnit.__proto__ || (0, _getPrototypeOf2.default)(ValueEngineUnit)).call(this));

        _this._valueWaitConnections = [];
        _this._multiplexWebSocketConnections = [];
        _this._multiplexWaitConnections = [];
        return _this;
    }

    (0, _createClass3.default)(ValueEngineUnit, [{
        key: 'updateEndpointsToResourceParts',
        value: function updateEndpointsToResourceParts(parts) {
            var _this2 = this;

            var valueWaitItems = new _map2.default();
            var multiplexWebSocketItems = new _map2.default();
            var multiplexWaitItems = new _map2.default();
            parts.forEach(function (part) {
                if (_MultiplexWebSocketConnection2.default.isWebSockHopAvailable && part.linkUris['MULTIPLEX_WS'] != null) {
                    var multiplexWebSocketPoll = (0, _utils.getOrCreateEntry)(multiplexWebSocketItems, part.linkUris['MULTIPLEX_WS'], function () {
                        return { items: [] };
                    });
                    multiplexWebSocketPoll.items.push(part);
                } else if (part.linkUris['MULTIPLEX_WAIT'] != null) {
                    var multiplexWaitPoll = (0, _utils.getOrCreateEntry)(multiplexWaitItems, part.linkUris['MULTIPLEX_WAIT'], function () {
                        return { items: [] };
                    });
                    multiplexWaitPoll.items.push(part);
                } else {
                    valueWaitItems.set(part.linkUris['VALUE_WAIT'], part);
                }
            });

            var valueWaitEndpoints = new _map2.default();
            var multiplexWebSocketEndpoints = new _map2.default();
            var multiplexWaitEndpoints = new _map2.default();
            multiplexWebSocketItems.forEach(function (endpoint, endpointUri) {
                multiplexWebSocketEndpoints.set(endpointUri, { endpointUri: endpointUri, items: endpoint.items });
            });
            multiplexWaitItems.forEach(function (endpoint, endpointUri) {
                if (endpoint.items.length > 1 || !endpoint.items[0].linkUris['VALUE_WAIT']) {
                    multiplexWaitEndpoints.set(endpointUri, { endpointUri: endpointUri, items: endpoint.items });
                } else {
                    valueWaitItems.set(endpoint.items[0].linkUris['VALUE_WAIT'], endpoint.items[0]);
                }
            });
            valueWaitItems.forEach(function (endpoint, endpointUri) {
                valueWaitEndpoints.set(endpointUri, { endpointUri: endpointUri, item: endpoint });
            });

            this.updateConnectionsToMatchEndpoints('Value Wait', this._valueWaitConnections, valueWaitEndpoints, function (endpoint) {
                return new _ValueWaitConnection2.default(_this2, endpoint);
            });
            this.updateConnectionsToMatchEndpoints('Multiplex Web Socket', this._multiplexWebSocketConnections, multiplexWebSocketEndpoints, function (endpoint) {
                return new _MultiplexWebSocketConnection2.default(_this2, endpoint);
            });
            this.updateConnectionsToMatchEndpoints('Multiplex Wait', this._multiplexWaitConnections, multiplexWaitEndpoints, function (endpoint) {
                return new _MultiplexWaitConnection2.default(_this2, endpoint);
            });
        }
    }, {
        key: 'createResourcePart',
        value: function createResourcePart(resourceHandler) {
            var _this3 = this;

            var resource = new _ValueResourcePart2.default(resourceHandler);

            var request = this.createLongPoll();
            request.on('finished', function (code, result, headers) {

                if (code >= 200 && code < 400) {
                    // 304 if not changed, don't trigger value
                    _this3.updateResourcePart(resource, headers, code < 300 ? result : null);

                    if (!resource.etag) {
                        Logger.info('no etag');
                    }
                    _this3.updateEngine();
                    request = null;
                } else if (code >= 400) {
                    if (code == 404) {
                        resourceHandler.forEachLiveResource(function (liveResource) {
                            return liveResource.trigger('removed', liveResource);
                        });
                        request = null;
                    } else {
                        request.retry();
                    }
                }
            });
            request.start('GET', resourceHandler.uri);

            return resource;
        }
    }, {
        key: 'updateResourcePart',
        value: function updateResourcePart(resourcePart, headers, result) {

            var parsedHeaders = ValueEngineUnit.parseHeaders(headers, resourcePart.resourceHandler.uri);

            if (parsedHeaders.etag) {
                resourcePart.etag = parsedHeaders.etag;
            }

            this.updateConnection(resourcePart, this._valueWaitConnections, 'VALUE_WAIT', parsedHeaders.valueWaitUri);
            this.updateConnection(resourcePart, this._multiplexWaitConnections, 'MULTIPLEX_WAIT', parsedHeaders.multiplexWaitUri);
            this.updateConnection(resourcePart, this._multiplexWebSocketConnections, 'MULTIPLEX_WS', parsedHeaders.multiplexWsUri);

            (0, _get3.default)(ValueEngineUnit.prototype.__proto__ || (0, _getPrototypeOf2.default)(ValueEngineUnit.prototype), 'updateResourcePart', this).call(this, resourcePart, headers, result);
        }
    }, {
        key: 'triggerEvents',
        value: function triggerEvents(part, headers, result) {
            var _this4 = this;

            if (result) {
                part.resourceHandler.forEachLiveResource(function (liveResource) {
                    // TODO: ContentType
                    var parsed = liveResource.parse(_this4.interestType, headers, result);
                    liveResource.trigger('value', liveResource, parsed);
                });
            }
        }
    }, {
        key: 'defaultParser',
        value: function defaultParser(headers, data) {
            return JSON.parse(data);
        }
    }, {
        key: 'interestType',
        get: function get() {
            return 'value';
        }
    }, {
        key: 'events',
        get: function get() {
            return ['value', 'removed'];
        }
    }], [{
        key: 'parseHeaders',
        value: function parseHeaders(headers, baseUri) {
            var etag = null;
            var valueWaitUri = null;
            var multiplexWaitUri = null;
            var multiplexWsUri = null;

            (0, _keys2.default)(headers).forEach(function (key) {
                var header = headers[key];

                var k = key.toLowerCase();
                if (k == 'etag') {
                    etag = header;
                } else if (k == 'link') {
                    var links = (0, _utils3.parseLinkHeader)(header);
                    if (links && links['value-wait']) {
                        valueWaitUri = (0, _utils.toAbsoluteUri)(baseUri, links['value-wait']['href']);
                    }
                    if (links && links['multiplex-wait']) {
                        multiplexWaitUri = (0, _utils.toAbsoluteUri)(baseUri, links['multiplex-wait']['href']);
                    }
                    if (links && links['multiplex-ws']) {
                        multiplexWsUri = (0, _utils2.mapHttpUrlToWebSocketUrl)((0, _utils.toAbsoluteUri)(baseUri, links['multiplex-ws']['href']));
                    }
                }
            });

            var result = {};

            if (etag) {
                Logger.info('etag: [' + etag + ']');
                result.etag = etag;
            }

            if (valueWaitUri) {
                Logger.info('value-wait: [' + valueWaitUri + ']');
                result.valueWaitUri = valueWaitUri;
            }

            if (multiplexWaitUri) {
                Logger.info('multiplex-wait: [' + multiplexWaitUri + ']');
                result.multiplexWaitUri = multiplexWaitUri;
            }

            if (multiplexWsUri) {
                Logger.info('multiplex-ws: [' + multiplexWsUri + ']');
                result.multiplexWsUri = multiplexWsUri;
            }

            return result;
        }
    }]);
    return ValueEngineUnit;
}(_EngineUnit3.default);

exports.default = ValueEngineUnit;

},{"../../Framework/EngineUnit":169,"../../Logger":175,"../../utils":178,"../../utils.mapWebSocketUrls":179,"../../utils.parseLinkHeader":180,"./MultiplexWaitConnection":161,"./MultiplexWebSocketConnection":162,"./ValueResourcePart":164,"./ValueWaitConnection":165,"babel-runtime/core-js/map":4,"babel-runtime/core-js/object/get-prototype-of":9,"babel-runtime/core-js/object/keys":10,"babel-runtime/helpers/classCallCheck":17,"babel-runtime/helpers/createClass":18,"babel-runtime/helpers/get":19,"babel-runtime/helpers/inherits":20,"babel-runtime/helpers/possibleConstructorReturn":21}],164:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _ResourcePart2 = require('../../Framework/ResourcePart');

var _ResourcePart3 = _interopRequireDefault(_ResourcePart2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValueResourcePart = function (_ResourcePart) {
    (0, _inherits3.default)(ValueResourcePart, _ResourcePart);

    function ValueResourcePart(resourceHandler) {
        (0, _classCallCheck3.default)(this, ValueResourcePart);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ValueResourcePart.__proto__ || (0, _getPrototypeOf2.default)(ValueResourcePart)).call(this, resourceHandler));

        _this.etag = null;
        _this.linkUris['VALUE_WAIT'] = null;
        _this.linkUris['MULTIPLEX_WAIT'] = null;
        _this.linkUris['MULTIPLEX_WS'] = null;
        return _this;
    }

    return ValueResourcePart;
}(_ResourcePart3.default);

exports.default = ValueResourcePart;

},{"../../Framework/ResourcePart":173,"babel-runtime/core-js/object/get-prototype-of":9,"babel-runtime/helpers/classCallCheck":17,"babel-runtime/helpers/inherits":20,"babel-runtime/helpers/possibleConstructorReturn":21}],165:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _Connection2 = require("../../Framework/Connection");

var _Connection3 = _interopRequireDefault(_Connection2);

var _Logger = require("../../Logger");

var Logger = _interopRequireWildcard(_Logger);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValueWaitConnection = function (_Connection) {
    (0, _inherits3.default)(ValueWaitConnection, _Connection);

    function ValueWaitConnection(engineUnit, endpoint) {
        (0, _classCallCheck3.default)(this, ValueWaitConnection);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ValueWaitConnection.__proto__ || (0, _getPrototypeOf2.default)(ValueWaitConnection)).call(this, engineUnit));

        _this.uri = endpoint.endpointUri;
        _this.request = engineUnit.createLongPoll();
        _this.res = endpoint.item;
        _this.isActive = false;

        _this.request.on("finished", function (code, result, headers) {
            _this.isActive = false;

            if (code >= 200 && code < 300) {
                engineUnit.updateResourcePart(_this.res, headers, result);
            }

            _this._engineUnit.updateEngine();
        });
        return _this;
    }

    (0, _createClass3.default)(ValueWaitConnection, [{
        key: "hasChanged",
        value: function hasChanged(endpoint) {
            return this.res.resourceHandler.uri != endpoint.item.resourceHandler.uri;
        }
    }, {
        key: "abort",
        value: function abort() {
            this.request.abort();
        }
    }, {
        key: "refresh",
        value: function refresh(endpoint) {
            if (!this.isActive) {
                var requestUri = this.uri;
                Logger.info("Value Wait Request URI: " + requestUri);
                this._engineUnit.setLongPollOptions(this.request);
                this.request.start('GET', requestUri, {
                    'If-None-Match': this.res.etag,
                    'Wait': 55
                });
                this.isActive = true;
            }
        }
    }]);
    return ValueWaitConnection;
}(_Connection3.default);

exports.default = ValueWaitConnection;

},{"../../Framework/Connection":167,"../../Logger":175,"babel-runtime/core-js/object/get-prototype-of":9,"babel-runtime/helpers/classCallCheck":17,"babel-runtime/helpers/createClass":18,"babel-runtime/helpers/inherits":20,"babel-runtime/helpers/possibleConstructorReturn":21}],166:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CollectionEntry = function CollectionEntry(id, deleted, item) {
    (0, _classCallCheck3.default)(this, CollectionEntry);

    this.id = id;
    this.deleted = deleted;
    this.item = item;
};

exports.default = CollectionEntry;

},{"babel-runtime/helpers/classCallCheck":17}],167:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Connection = function () {
    function Connection(engineUnit) {
        (0, _classCallCheck3.default)(this, Connection);

        this._engineUnit = engineUnit;
    }

    (0, _createClass3.default)(Connection, [{
        key: "hasChanged",
        value: function hasChanged(endpoint) {
            throw false;
        }
    }, {
        key: "abort",
        value: function abort() {}
    }, {
        key: "refresh",
        value: function refresh(endpoint) {}
    }]);
    return Connection;
}();

exports.default = Connection;

},{"babel-runtime/helpers/classCallCheck":17,"babel-runtime/helpers/createClass":18}],168:[function(require,module,exports){
(function (process){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _map = require('babel-runtime/core-js/map');

var _map2 = _interopRequireDefault(_map);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _utils = require('../utils');

var _Logger = require('../Logger');

var Logger = _interopRequireWildcard(_Logger);

var _ResourceHandler = require('./ResourceHandler');

var _ResourceHandler2 = _interopRequireDefault(_ResourceHandler);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Engine = function () {
    function Engine() {
        (0, _classCallCheck3.default)(this, Engine);

        this._resourceHandlers = new _map2.default();
        this._engineUnits = [];
        this._updatePending = false;

        this.options = {
            longPollTimeoutMsecs: 0,
            maxLongPollDelayMsecs: 0
        };
    }

    (0, _createClass3.default)(Engine, [{
        key: 'setGlobalOptions',
        value: function setGlobalOptions(options) {
            this.options = options;
        }
    }, {
        key: 'getHandlerForUri',
        value: function getHandlerForUri(uri) {
            var _this = this;

            return (0, _utils.getOrCreateEntry)(this._resourceHandlers, uri, function () {
                return new _ResourceHandler2.default(_this, uri);
            });
        }
    }, {
        key: 'getAllResourcePartsForInterestType',
        value: function getAllResourcePartsForInterestType(interestType) {
            var resourceParts = [];

            this._resourceHandlers.forEach(function (resourceHandler) {
                var resourcePart = resourceHandler.getResourcePart(interestType);
                if (resourcePart != null) {
                    resourceParts.push(resourcePart);
                }
            });

            return resourceParts;
        }
    }, {
        key: 'update',
        value: function update() {
            var _this2 = this;

            if (this._updatePending) {
                // Do nothing if we already have a pending update,
                return;
            }
            this._updatePending = true;

            process.nextTick(function () {
                _this2._updatePending = false;

                // restart our long poll
                Logger.info('engine: setup long polls');

                _this2._engineUnits.forEach(function (engineUnit) {
                    engineUnit.update();
                });
            });
        }
    }, {
        key: 'addEngineUnit',
        value: function addEngineUnit(engineUnit) {
            this._engineUnits.push(engineUnit);
            engineUnit.engine = this;
        }
    }, {
        key: 'findEngineUnitForEvent',
        value: function findEngineUnitForEvent(eventName) {
            return this._engineUnits.find(function (engineUnit) {
                return engineUnit.events.indexOf(eventName) >= 0;
            });
        }
    }, {
        key: 'findEngineUnitForInterestType',
        value: function findEngineUnitForInterestType(interestType) {
            return this._engineUnits.find(function (engineUnit) {
                return engineUnit.interestType == interestType;
            });
        }
    }, {
        key: 'defaultParser',
        value: function defaultParser(interestType, headers, data) {
            var engineUnit = this.findEngineUnitForInterestType(interestType);
            return engineUnit != null ? engineUnit.defaultParser(headers, data) : null;
        }
    }]);
    return Engine;
}();

exports.default = Engine;

}).call(this,require('_process'))
},{"../Logger":175,"../utils":178,"./ResourceHandler":172,"_process":148,"babel-runtime/core-js/map":4,"babel-runtime/helpers/classCallCheck":17,"babel-runtime/helpers/createClass":18}],169:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _map = require("babel-runtime/core-js/map");

var _map2 = _interopRequireDefault(_map);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _Logger = require("../Logger");

var Logger = _interopRequireWildcard(_Logger);

var _pollymer = require("pollymer");

var _pollymer2 = _interopRequireDefault(_pollymer);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EngineUnit = function () {
    function EngineUnit() {
        (0, _classCallCheck3.default)(this, EngineUnit);

        this.engine = null;
    }

    (0, _createClass3.default)(EngineUnit, [{
        key: "update",
        value: function update() {
            var resourceParts = this.engine.getAllResourcePartsForInterestType(this.interestType);
            this.updateEndpointsToResourceParts(resourceParts);
        }
    }, {
        key: "updateEndpointsToResourceParts",
        value: function updateEndpointsToResourceParts(resourceParts) {}
    }, {
        key: "updateEngine",
        value: function updateEngine() {
            this.engine.update();
        }
    }, {
        key: "createResourcePart",
        value: function createResourcePart(resourceHandler) {
            return null;
        }
    }, {
        key: "updateResources",
        value: function updateResources(uri, headers, result) {
            var resourceHandler = this.engine.getHandlerForUri(uri);
            var resourcePart = resourceHandler.getResourcePart(this.interestType);
            if (resourcePart != null) {
                this.updateResourcePart(resourcePart, headers, result);
            }
        }
    }, {
        key: "updateResourcePart",
        value: function updateResourcePart(resourcePart, headers, result) {
            this.triggerEvents(resourcePart, headers, result);
        }
    }, {
        key: "triggerEvents",
        value: function triggerEvents(resourcePart, headers, result) {}
    }, {
        key: "createLongPoll",
        value: function createLongPoll() {
            var request = new _pollymer2.default.Request();
            this.setLongPollOptions(request);
            return request;
        }
    }, {
        key: "setLongPollOptions",
        value: function setLongPollOptions(request) {
            // We are going to use 'parser' to do this
            request.rawResponse = true;

            if (this.engine.options.longPollTimeoutMsecs) {
                request.timeout = this.engine.options.longPollTimeoutMsecs;
            } else {
                request.timeout = 60000;
            }
            if (this.engine.options.maxLongPollDelayMsecs) {
                request.maxDelay = this.engine.options.maxLongPollDelayMsecs;
            } else {
                request.maxDelay = 1000;
            }
        }
    }, {
        key: "updateConnectionsToMatchEndpoints",
        value: function updateConnectionsToMatchEndpoints(label, currentConnections, preferredEndpointsMap, createConnectionFunc) {

            // currentConnectionsMap is a mapping of endpointUri -> connection
            // preferredEndpointsMap is a mapping of endpointUri -> endpoint to update to

            var currentConnectionsMap = new _map2.default();
            currentConnections.forEach(function (item) {
                currentConnectionsMap.set(item.uri, item);
            });

            // Keep track of list of new endpoints to enable
            var newEndpoints = new _map2.default();
            preferredEndpointsMap.forEach(function (endpoint, endpointUri) {
                newEndpoints.set(endpointUri, endpoint);
            });

            // Make a list of endpoints to disable...
            var endpointsToDisable = [];
            currentConnectionsMap.forEach(function (connection, endpointUri) {
                // This item is already known, so remove endpoint from "new endpoints".
                newEndpoints.delete(endpointUri);

                var removedOrChanged = false;
                if (!preferredEndpointsMap.has(endpointUri)) {
                    // If item is not in the preferred endpoints map, then it has been
                    // removed. Mark for disabling.
                    removedOrChanged = true;
                } else {
                    // If item is in the preferred endpoints map, then
                    // call "changeTest" to decide whether this item has changed.
                    var endpoint = preferredEndpointsMap.get(endpointUri);
                    removedOrChanged = connection.hasChanged(endpoint);
                }
                if (removedOrChanged) {
                    // If marked, add to "delete" list
                    endpointsToDisable.push(endpointUri);
                }
            });

            // ... and disable them.
            endpointsToDisable.forEach(function (endpointUri) {
                Logger.info("Remove '" + label + "' endpoint - '" + endpointUri + "'.");
                var connection = currentConnectionsMap.get(endpointUri);
                connection.abort();
                currentConnectionsMap.delete(endpointUri);
            });

            // Create new requests for endpoints that need them.
            newEndpoints.forEach(function (endpoint, endpointUri) {
                Logger.info("Adding '" + label + "' endpoint - '" + endpointUri + "'.");
                currentConnectionsMap.set(endpointUri, createConnectionFunc(endpoint));
            });

            // For any current endpoint, make sure they are running.
            currentConnections.length = 0;
            currentConnectionsMap.forEach(function (connection, endpointUri) {
                var endpoint = preferredEndpointsMap.get(endpointUri);
                connection.refresh(endpoint);
                currentConnections.push(connection);
            });
        }
    }, {
        key: "updateConnection",
        value: function updateConnection(resourcePart, connections, linkType, newLinkUri) {
            if (newLinkUri) {
                var connection = connections.find(function (conn) {
                    return conn.uri === resourcePart.linkUris[linkType];
                });
                if (connection != null) {
                    connection.uri = newLinkUri;
                }
                resourcePart.linkUris[linkType] = newLinkUri;
            }
        }
    }, {
        key: "defaultParser",
        value: function defaultParser(headers, data) {
            // return null for unknown data type.
            return null;
        }
    }, {
        key: "interestType",
        get: function get() {
            return null;
        }
    }, {
        key: "events",
        get: function get() {
            return null;
        }
    }], [{
        key: "parseHeaders",
        value: function parseHeaders(headers, baseUri) {}
    }]);
    return EngineUnit;
}();

exports.default = EngineUnit;

},{"../Logger":175,"babel-runtime/core-js/map":4,"babel-runtime/helpers/classCallCheck":17,"babel-runtime/helpers/createClass":18,"pollymer":147}],170:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Events = function () {
    function Events() {
        (0, _classCallCheck3.default)(this, Events);

        this._events = {};
    }

    (0, _createClass3.default)(Events, [{
        key: "on",
        value: function on(type, handler) {
            var _this = this;

            if (this._events[type] == null) {
                this._events[type] = [];
            }

            this._events[type].push(handler);
            return function () {
                if (_this._events[type] != null) {
                    _this._events[type] = _this._events[type].filter(function (h) {
                        return h != handler;
                    });
                }
            };
        }
    }, {
        key: "trigger",
        value: function trigger(type, obj) {
            for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
                args[_key - 2] = arguments[_key];
            }

            if (this._events[type] != null) {
                this._events[type].slice().forEach(function (handler) {
                    return handler.apply(obj, args);
                });
            }
        }
    }]);
    return Events;
}();

;

exports.default = Events;

},{"babel-runtime/helpers/classCallCheck":17,"babel-runtime/helpers/createClass":18}],171:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _utils = require('../utils');

var _utils2 = require('../utils.getWindowLocationHref');

var _Events = require('./Events');

var _Events2 = _interopRequireDefault(_Events);

var _CollectionEntry = require('./CollectionEntry');

var _CollectionEntry2 = _interopRequireDefault(_CollectionEntry);

var _Logger = require('../Logger');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LiveResource = function () {
    function LiveResource(staticClass, engine, uri, options) {
        (0, _classCallCheck3.default)(this, LiveResource);

        this._events = new _Events2.default();
        this._engine = engine;

        if ((typeof uri === 'undefined' ? 'undefined' : (0, _typeof3.default)(uri)) == "object") {
            options = uri;
            uri = undefined;
        }

        options = options || {};

        var resourceUri = uri || options.uri;
        this._parser = options.parser;

        // staticClass is a reference to the "class" used in global scope, e.g., Liveresource.options
        // This is a hacky way of setting options on the engine, may want to revisit
        engine.setGlobalOptions(staticClass.options);

        var windowLocationHref = (0, _utils2.getWindowLocationHref)();
        var absoluteUri = (0, _utils.toAbsoluteUri)(windowLocationHref, resourceUri);
        this._resourceHandler = engine.getHandlerForUri(absoluteUri);
        this._resourceHandler.addLiveResource(this);
    }

    (0, _createClass3.default)(LiveResource, [{
        key: 'parse',
        value: function parse(interestType, headers, data) {
            return this._parser ? this._parser(interestType, headers, data) : this._engine.defaultParser(interestType, headers, data);
        }
    }, {
        key: 'on',
        value: function on(type, handler) {
            var event = this._events.on(type, handler);
            this._resourceHandler.addEvent(type);
            return function () {
                event();
                // Also remove from resource handler
            };
        }
    }, {
        key: 'trigger',
        value: function trigger(event, target) {
            var _events;

            for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
                args[_key - 2] = arguments[_key];
            }

            (_events = this._events).trigger.apply(_events, [event, target].concat(args));
        }
    }, {
        key: 'cancel',
        value: function cancel() {
            this._events = null;
            if (this._resourceHandler != null) {
                this._resourceHandler.removeLiveResource(this);
                this._resourceHandler = null;
            }
        }
    }], [{
        key: 'createLiveResourceConstructorWithEngine',
        value: function createLiveResourceConstructorWithEngine(engine) {
            var LiveResourceClass = function LiveResourceClass(uri, options) {
                (0, _classCallCheck3.default)(this, LiveResourceClass);

                return new LiveResource(this.constructor, engine, uri, options);
            };
            // TODO: Probably better to do this another way.
            // This is flaky.
            LiveResourceClass.options = {
                longPollTimeoutMsecs: 0,
                maxLongPollDelayMsecs: 0
            };
            LiveResourceClass.CollectionEntry = _CollectionEntry2.default;

            LiveResourceClass.logger = null;
            if ('development' === 'development') {
                LiveResourceClass.logger = function (type, message) {
                    console.log('LiveResource: ' + type + ' - ' + message);
                };
            }

            (0, _Logger.addLogger)(LiveResourceClass);

            return LiveResourceClass;
        }
    }]);
    return LiveResource;
}();

exports.default = LiveResource;

},{"../Logger":175,"../utils":178,"../utils.getWindowLocationHref":177,"./CollectionEntry":166,"./Events":170,"babel-runtime/helpers/classCallCheck":17,"babel-runtime/helpers/createClass":18,"babel-runtime/helpers/typeof":23}],172:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _map = require("babel-runtime/core-js/map");

var _map2 = _interopRequireDefault(_map);

var _weakMap = require("babel-runtime/core-js/weak-map");

var _weakMap2 = _interopRequireDefault(_weakMap);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _Logger = require("../Logger");

var Logger = _interopRequireWildcard(_Logger);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResourceHandler = function () {
    function ResourceHandler(engine, uri) {
        (0, _classCallCheck3.default)(this, ResourceHandler);

        this._engine = engine;
        this.uri = uri;

        // The "parts" of this resource.
        this._resourceParts = [];

        // References to the "LiveResource" instances
        // that are pointed to by this resource handler
        this._liveResources = [];

        // TODO: "once only" events need to go away.
        // 'ready' is the only one using this right now, and
        // it's not the right way.
        this._onceOnlyEventMap = new _weakMap2.default();
        this._onceOnlyEvents = new _map2.default();
    }

    (0, _createClass3.default)(ResourceHandler, [{
        key: "addLiveResource",
        value: function addLiveResource(liveResource) {
            this._liveResources.push(liveResource);
            this._onceOnlyEventMap.set(liveResource, []);
        }
    }, {
        key: "removeLiveResource",
        value: function removeLiveResource(liveResource) {
            this._liveResources = this._liveResources.filter(function (x) {
                return x != liveResource;
            });
        }
    }, {
        key: "forEachLiveResource",
        value: function forEachLiveResource(callback) {
            this._liveResources.forEach(function (liveResource) {
                return callback(liveResource);
            });
        }
    }, {
        key: "triggerOnceOnlyEvent",
        value: function triggerOnceOnlyEvent(event, target) {
            for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
                args[_key - 2] = arguments[_key];
            }

            this._onceOnlyEvents.set(event, { target: target, args: args });
            this.checkOnceOnlyEvents();
        }
    }, {
        key: "checkOnceOnlyEvents",
        value: function checkOnceOnlyEvents() {
            var _this = this;

            Logger.info("Checking once only events...");

            this._onceOnlyEvents.forEach(function (_ref, event) {
                var target = _ref.target,
                    args = _ref.args;

                _this._liveResources.forEach(function (liveResource) {
                    var processedEvents = _this._onceOnlyEventMap.get(liveResource);
                    if (processedEvents.indexOf(event) < 0) {
                        var _liveResource$_events;

                        processedEvents.push(event);
                        (_liveResource$_events = liveResource._events).trigger.apply(_liveResource$_events, [event, target].concat((0, _toConsumableArray3.default)(args)));
                    }
                });
            });
        }
    }, {
        key: "addEvent",
        value: function addEvent(type) {
            var _this2 = this;

            var engineUnit = this._engine.findEngineUnitForEvent(type);
            var interestType = engineUnit != null ? engineUnit.interestType : null;
            if (interestType != null) {
                this.getOrAddResourcePart(interestType, function (type) {
                    return engineUnit.createResourcePart(_this2);
                });
            }

            this.checkOnceOnlyEvents();
        }
    }, {
        key: "getOrAddResourcePart",
        value: function getOrAddResourcePart(interestType, createFunc) {
            if (interestType != null) {
                var resourcePart = this._resourceParts.find(function (part) {
                    return part.interestType == interestType;
                });
                if (resourcePart == null && createFunc != null) {
                    resourcePart = { interestType: interestType, part: createFunc(interestType) };
                    this._resourceParts.push(resourcePart);
                }
                return resourcePart != null ? resourcePart.part : null;
            }
            return null;
        }
    }, {
        key: "getResourcePart",
        value: function getResourcePart(interestType) {
            return this.getOrAddResourcePart(interestType, null);
        }
    }]);
    return ResourceHandler;
}();

exports.default = ResourceHandler;

},{"../Logger":175,"babel-runtime/core-js/map":4,"babel-runtime/core-js/weak-map":15,"babel-runtime/helpers/classCallCheck":17,"babel-runtime/helpers/createClass":18,"babel-runtime/helpers/toConsumableArray":22}],173:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResourcePart = function ResourcePart(resourceHandler) {
    (0, _classCallCheck3.default)(this, ResourcePart);

    this.resourceHandler = resourceHandler;
    this.linkUris = {};
};

exports.default = ResourcePart;

},{"babel-runtime/helpers/classCallCheck":17}],174:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Engine = require('./Framework/Engine');

var _Engine2 = _interopRequireDefault(_Engine);

var _ValueEngineUnit = require('./EngineUnits/Value/ValueEngineUnit');

var _ValueEngineUnit2 = _interopRequireDefault(_ValueEngineUnit);

var _ChangesEngineUnit = require('./EngineUnits/Changes/ChangesEngineUnit');

var _ChangesEngineUnit2 = _interopRequireDefault(_ChangesEngineUnit);

var _LiveResource = require('./Framework/LiveResource');

var _LiveResource2 = _interopRequireDefault(_LiveResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var engine = new _Engine2.default();

// 2. Add engine units
// Build the default LiveResource constructor

// 1. Create a new engine

var valueEngineUnit = new _ValueEngineUnit2.default();
engine.addEngineUnit(valueEngineUnit);

var changesEngineUnit = new _ChangesEngineUnit2.default();
engine.addEngineUnit(changesEngineUnit);

// 3. Create a constructor that would create LiveResource instances
// associated with this engine.

var liveResourceClass = _LiveResource2.default.createLiveResourceConstructorWithEngine(engine);

exports.default = liveResourceClass;

},{"./EngineUnits/Changes/ChangesEngineUnit":158,"./EngineUnits/Value/ValueEngineUnit":163,"./Framework/Engine":168,"./Framework/LiveResource":171}],175:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.addLogger = addLogger;
exports.log = log;
exports.debug = debug;
exports.info = info;
exports.warn = warn;
exports.error = error;
var _loggers = [];

// Add an object that has a .logger member
function addLogger(obj) {
    _loggers.push(obj);
}

function log(type, message) {

    _loggers.forEach(function (obj) {
        if (obj.logger != null) {
            obj.logger(type, message);
        }
    });
}

function debug(message) {
    log('debug', message);
}

function info(message) {
    log('info', message);
}

function warn(message) {
    log('warn', message);
}

function error(message) {
    log('error', message);
}

},{}],176:[function(require,module,exports){
"use strict";

var _LiveResource = require("./LiveResource");

var _LiveResource2 = _interopRequireDefault(_LiveResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _LiveResource2.default;

},{"./LiveResource":174}],177:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getWindowLocationHref = exports.getWindowLocationHref = function getWindowLocationHref() {
  return window.location.href;
};

},{}],178:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var toAbsoluteUri = exports.toAbsoluteUri = function toAbsoluteUri(base, href) {
    // RFC 3986

    function parseURI(url) {
        var m = String(url).replace(/^\s+|\s+$/g, '').match(/^([^:\/?#]+:)?(\/\/(?:[^:@]*(?::[^:@]*)?@)?(([^:\/?#]*)(?::(\d*))?))?([^?#]*)(\?[^#]*)?(#[\s\S]*)?/);
        // authority = '//' + user + ':' + pass '@' + hostname + ':' port
        return m ? {
            href: m[0] || '',
            protocol: m[1] || '',
            authority: m[2] || '',
            host: m[3] || '',
            hostname: m[4] || '',
            port: m[5] || '',
            pathname: m[6] || '',
            search: m[7] || '',
            hash: m[8] || ''
        } : null;
    }

    function removeDotSegments(input) {
        var output = [];
        input.replace(/^(\.\.?(\/|$))+/, '').replace(/\/(\.(\/|$))+/g, '/').replace(/\/\.\.$/, '/../').replace(/\/?[^\/]*/g, function (p) {
            if (p === '/..') {
                output.pop();
            } else {
                output.push(p);
            }
        });
        return output.join('').replace(/^\//, input.charAt(0) === '/' ? '/' : '');
    }

    href = parseURI(href || '');
    base = parseURI(base || '');

    return !href || !base ? null : (href.protocol || base.protocol) + (href.protocol || href.authority ? href.authority : base.authority) + removeDotSegments(href.protocol || href.authority || href.pathname.charAt(0) === '/' ? href.pathname : href.pathname ? (base.authority && !base.pathname ? '/' : '') + base.pathname.slice(0, base.pathname.lastIndexOf('/') + 1) + href.pathname : base.pathname) + (href.protocol || href.authority || href.pathname ? href.search : href.search || base.search) + href.hash;
};

var beginsWith = exports.beginsWith = function beginsWith(str, find) {
    return str.substring(0, find.length) == find;
};

var replaceStart = exports.replaceStart = function replaceStart(str, find, replace) {
    return replace + str.substring(find.length);
};

var getOrCreateEntry = exports.getOrCreateEntry = function getOrCreateEntry(map, key, create) {
    var obj = void 0;
    if (!map.has(key)) {
        obj = create();
        map.set(key, obj);
    } else {
        obj = map.get(key);
    }
    return obj;
};

},{}],179:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapWebSocketUrlToHttpUrl = exports.mapHttpUrlToWebSocketUrl = undefined;

var _utils = require('./utils');

var _utils2 = require('./utils.getWindowLocationHref');

var mapHttpUrlToWebSocketUrl = exports.mapHttpUrlToWebSocketUrl = function mapHttpUrlToWebSocketUrl(url) {
    var windowLocationHref = (0, _utils2.getWindowLocationHref)();
    var absoluteUri = (0, _utils.toAbsoluteUri)(windowLocationHref, url);

    var converted = absoluteUri;
    if ((0, _utils.beginsWith)(absoluteUri, "http://")) {
        converted = (0, _utils.replaceStart)(absoluteUri, "http://", "ws://");
    } else if ((0, _utils.beginsWith)(absoluteUri, "https://")) {
        converted = (0, _utils.replaceStart)(absoluteUri, "https://", "wss://");
    }

    if (!(0, _utils.beginsWith)(converted, "ws://") && !(0, _utils.beginsWith)(converted, "wss://")) {
        throw "not valid";
    }

    return converted;
};

var mapWebSocketUrlToHttpUrl = exports.mapWebSocketUrlToHttpUrl = function mapWebSocketUrlToHttpUrl(url) {
    var converted = url;
    if ((0, _utils.beginsWith)(url, "ws://")) {
        converted = (0, _utils.replaceStart)(url, "ws://", "http://");
    } else if ((0, _utils.beginsWith)(url, "wss://")) {
        converted = (0, _utils.replaceStart)(url, "wss://", "https://");
    }

    if (!(0, _utils.beginsWith)(converted, "http://") && !(0, _utils.beginsWith)(converted, "https://")) {
        throw "not valid";
    }

    return converted;
};

},{"./utils":178,"./utils.getWindowLocationHref":177}],180:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseLinkHeader = undefined;

var _Logger = require('./Logger');

var Logger = _interopRequireWildcard(_Logger);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// TODO: REFACTOR THIS
// ** PARSE LINK HEADER **
// returns object with structure:
//   { reltype1: { href: url, otherparam1: val }, reltype2: { ... } }
// or return null if parse fails

var parseLinkHeader = exports.parseLinkHeader = function parseLinkHeader(header) {
    if (header.length == 0) {
        return null;
    }

    var links = {};

    var at = 0;
    var readLink = true;
    while (readLink) {
        // skip ahead to next non-space char
        for (; at < header.length; ++at) {
            if (header[at] != ' ') break;
        }
        if (at >= header.length || header[at] != '<') return null;

        var start = at + 1;
        var end = header.indexOf('>', at);
        if (end == -1) return null;

        var url = header.substring(start, end);

        at = end + 1;

        readLink = false;
        var readParams = false;
        if (at < header.length) {
            if (header[at] == ',') {
                readLink = true;
                ++at;
            } else if (header[at] == ';') {
                readParams = true;
                ++at;
            } else {
                return null;
            }
        }

        var rel = null;
        var params = {};
        while (readParams) {
            // skip ahead to next non-space char
            for (; at < header.length; ++at) {
                if (header[at] != ' ') break;
            }
            if (at >= header.length) return null;

            start = at;

            // find end of param name
            for (; at < header.length; ++at) {
                if (header[at] == '=' || header[at] == ',' || header[at] == ';') break;
            }
            end = at;

            var name = header.substring(start, end);
            var val = null;

            if (at < header.length && header[at] == '=') {
                // read value
                ++at;
                if (at < header.length && header[at] == '\"') {
                    start = at + 1;

                    // find end of quoted param value
                    at = header.indexOf('\"', start);
                    if (at == -1) return null;
                    end = at;

                    val = header.substring(start, end);

                    ++at;
                } else {
                    start = at;

                    // find end of param value
                    for (; at < header.length; ++at) {
                        if (header[at] == ',' || header[at] == ';') break;
                    }
                    end = at;

                    val = header.substring(start, end);
                }
            }

            readParams = false;
            if (at < header.length) {
                if (header[at] == ',') {
                    readLink = true;
                    ++at;
                } else if (header[at] == ';') {
                    readParams = true;
                    ++at;
                } else {
                    return null;
                }
            }

            if (name == 'rel') rel = val;else params[name] = val;
        }

        if (rel) {
            var rels = rel.split(' ');
            for (var i = 0; i < rels.length; ++i) {
                Logger.debug('link: url=[' + url + '], rel=[' + rels[i] + ']');
                var link = {};
                link.rel = rels[i];
                link.href = url;
                for (var paramName in params) {
                    if (!params.hasOwnProperty(paramName)) continue;
                    link[paramName] = params[paramName];
                }
                links[link.rel] = link;
            }
        }
    }

    return links;
};

},{"./Logger":175}]},{},[176])(176)
});


//////////////////
// WEBPACK FOOTER
// /home/justin/dev/todomvc-liveresource-website/~/liveresource/dist/liveresource.js
// module id = 570
// module chunks = 0